import styled, { keyframes, css } from 'styled-components';
import {PDFDownloadLink} from '@react-pdf/renderer';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


// -------------
// ANIMATIONS
// -------------

// Keyframes for shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const blink = keyframes`
  0% {
    opacity: 1;
  }
  49% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`;


const animateRainbow = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const breathe = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: rgba(60, 66, 87, 0.06) 0px 0px 6px 0px, inset rgba(0, 0, 0, 0.06) 0px 3px 6px 0px;
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    box-shadow: rgba(60, 66, 87, 0.12) 0px 0px 12px 0px, inset rgba(0, 0, 0, 0.12) 0px 3px 12px 0px;
    opacity: 1;
  }
`;


export const LiveBubble = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    gap:5px;
    padding-right:20px
`

export const PublishedText = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-size:12px;
    color: rgb(88, 192, 164);
    
`

export const ShowingLive = styled.div`
    width: 10px;
    height: 10px;
    background: rgb(88, 192, 164);
    border-radius: 50%;
    animation: ${pulse} 1s infinite;
`

export const SetUpPageHeading = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
`

export const OverallOptionField = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    padding:10px;
`

export const EachBox = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:200px;
    height:100px;
    background: #000000;
    border-radius:5px;
    color:#ffffff;

`

export const EachBoxHead = styled.div`
    font-size:30px;
    color:#ffffff;
`

export const EachBoxSub = styled.div`
    font-size:15px;
    color:#ffffff;    
`
 

export const DisplayLeft = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
`



export const DisplayRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
    align-items:flex-end;
    align-content:flex-end;
    width:100%;
`

export const AccountTypeSelector = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    background: #ffffff;
`

export const OptionSelected = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    flex: 1;
    background: ${props => !props.selected ? '#f3f3f3' : 'transparent'};
    color: ${props => !!props.selected ? 'rgba(26, 55, 100, 1)' : 'rgb(26, 55, 100, 0.5)'};
    border-${props => props.borderRadius}-radius:30px;
    width:100%;
    transition: all 0.3s;
    height:50px;
    cursor:pointer;
    ${props => !props.selected && `
            box-shadow: inset rgba(60, 66, 87, 0.06) 0px 0px 10px 0px, inset rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
    `}

    ${props => !props.selected && `
         &:hover {
            background: rgba(27, 58, 103, 0.1);
        }
    `}

`

export const Cursor = styled.span`
    display: inline-block;
    width: 1ch;
    animation: ${blink} 1s steps(2, start) infinite;
`

export const Dot = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;   
    width:2px;
    height:20px;
    background: #e5e5e5;
    border-radius:100px;
    margin-left:10px;
    margin-right:10px;
`

export const OverallShow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;
`

export const TopExplainer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:14px;
    color: #000000;
    padding-bottom:30px;
`

export const FooterSpacer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:150px;
    width:300px;   
    flex-grow:0;
    flex-shrink:0;
`

export const HeadingSpacer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:110px;
    width:300px;   
    background:red;
`

export const OverallShowColumn = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:20px;
`

export const ProcessError = styled.span`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: rgb(210, 4, 45);
    font-family: newFontFaceBold;
    font-size: 14px;
`

export const LogoMini = styled.img`
        width: 23px;
`


export const LabelAtEnd = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:13px;
    font-family:newFontFace;
    border-radius:10px;
    color: green;
    padding:5px 20px;
    background:rgba(0, 191, 165, 0.2);
`


export const EachTool = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 0; /* Important to prevent overflow in grid */
    border-radius: 10px;
    border: 1px solid #d5d5d5;
    background: #ffffff;
    overflow:hidden;
`


export const SplitSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    flex: 1;
    min-width:300px;
    width:100%;
    padding:20px;
    border-radius:10px;
    border:1px solid #d5d5d5;
    background:rgba(255,255,255,0.8);
`

export const SideBy = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    flex-wrap:wrap;
    width:100%;
    gap:30px;
    padding-bottom:50px;
`

export const SideByTools = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    align-items: stretch;
    flex-wrap:wrap;
    width:100%;
    padding-bottom:50px;

`


export const ProcessErrorLarge = styled.span`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: rgb(210, 4, 45);
    font-family: newFontFaceBold;
    font-size: 18px;
    text-align:center;
`

export const ButtonActivation = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    background: rgba(237,241,245,0.8);
    border-radius:10px;
    padding:5px 20px;
    font-size:14px;
    color:#a9a9a9;
    font-family:newFontFace;
`

export const RoomWrapper = styled.div`
    position:relative;
    width:100%;
    height:100vh;
    min-height: 100vh;
`
export const ActiveDot = styled.div`
    width: 12px;
    height: 12px;
    background-color: ${props => props.color || 'rgba(0, 191, 165,1)'};
    border-radius: 50%;
    animation: ${breathe} 1.5s ease-in-out infinite;
    animation-delay: ${props => props.delay || '0s'};
    position:absolute;
    left:0;
    top:0;
    margin-left:-5px; 
    margin-top:-5px;
    border:2px solid #ffffff;
`

export const BubblingDot = styled.div`
  width: 14px;
  height: 14px;
  background-color: ${props => props.color || '#000000'};
  border-radius: 50%;
  animation: ${breathe} 1.5s ease-in-out infinite;
  animation-delay: ${props => props.delay || '0s'};
  margin: 0 4px;
  position:absolute;
  bottom:0;
`;

export const BubblingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position:relative;
`;

export const Bubbling = styled.div`
    width: 14px;
    height: 14px;
    background-color: #000000;
    border-radius: 50%;
    animation: ${breathe} 1.5s ease-in-out infinite;
`

export const TopItem = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:absolute;
    top:10px;
    right:10px;
    z-index:100000;
`

export const LogoContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(26, 55, 100);
    height:40px;
    width:40px;
    border-radius:10px;
`


export const NavBarHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:12px;
    color: #a9a9a9;
    width: 100%;
    text-align:center;
    font-family: newFontFace;
    padding-top:10px;
    padding-bottom:10px;
    z-index:10000;
`

export const MiniLogo = styled.img`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:30px;
`

export const MiniBox = styled.span`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:3px;
    padding:5px 10px;
    font-size:13px;
    background: #d5d5d5;
`

export const GroupOfItems = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    overflow:scroll;
    gap:5px;
    margin-top:10px;
    padding-bottom:20px;
    border-bottom:1px solid ${props => props.showBottomLines ? 'rgba(0,0,0,0.1)' : 'transparent'};
    border-top:1px solid ${props => props.showTopLines ? 'rgba(0,0,0,0.1)' : 'transparent'};
    width:100%;
    height:100%;
    transition: all 0.5s;

    &:hover {
        border-bottom:1px solid rgba(0,0,0,0.1);
    }
`

export const OptionsListShown = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    max-height:350px;
    overflow:scroll;
    width:110%;
    padding:5%;
    border-bottom:1px solid #f1f1f1;
    box-shadow: inset rgba(60, 66, 87, 0.06) 0px 0px 5px 0px, inset rgba(0, 0, 0, 0.06) 0px 3px 5px 0px;
    z-index:500;
    transition: all 0.3s;
`

export const HeadingSmall = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    width:100%;
    font-size:18px;
    font-family: newFontFaceBold;
    padding:10px 20px;
    padding-bottom:20px;
    border-bottom:1px solid #e5e5e5;

`

export const VideoConferenceOutline = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;

`

export const LocalCameraElement = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:100%;
    width:350px;
    flex-grow:1;
    overflow:hidden;
    border-radius:30px;
    box-shadow: rgba(16, 24, 40, 0.08) 0px 12px 16px -4px, rgba(16, 24, 40, 0.03) 0px 4px 6px -2px;
    background:rgba(255,255,255,0.7);
    border: 1px solid #E2E8F0;

`

export const HeadingSmallNoBorder = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    width:100%;
    font-size:18px;
    font-family: newFontFaceBold;
    padding:10px 20px;
    z-index:1000;
    background:#ffffff;
   
`


export const EachEmptyCategoryTitleOverall = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;

`

export const EachEmptyCategoryTitle = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    color: #ffffff;

`

export const OverallSectionPrompt = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    width:100%;
    max-width:800px;
    position:relative;
`

export const MessageCorridor = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    gap:10px;
    width:100%;
`

export const PromptTranscription = styled.div`
    display:${props => props.micOn ? 'flex' : 'none'}
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    padding:10px;
    overflow:hidden;
    border-radius:30px;
    transition: all 0.5s;
    box-shadow: rgba(16, 24, 40, 0.08) 0px 12px 16px -4px, rgba(16, 24, 40, 0.03) 0px 4px 6px -2px;
    border: 1px solid ${props => props.videoMode ? 'transparent' : '#E2E8F0'};
    background:${props => props.videoMode ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,1)'};
    font-size:13px;
    color:#a9a9a9;
    text-align:center;

`

export const PromptInput = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width: ${props => (props.videoMode && props.speakMode) ? '0px' : (props.speakMode ? '400px' : '100%')};
    margin-bottom: ${props => props.speakMode ? '40px' : '0px'};
    height:${props => (props.videoMode && props.speakMode) ? '0px' : (props.speakMode ? '40px' : 'auto')};
    border-radius:30px;
    overflow:hidden;
    box-shadow: rgba(16, 24, 40, ${props => props.micOn ? '0.03' : '0.08'}) 0px 12px 16px -4px, rgba(16, 24, 40, 0.03) 0px 4px 6px -2px;
    background:${props => props.videoMode ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,1)'};
    border: 1px solid ${props => props.videoMode ? 'transparent' : '#E2E8F0'};
    transition: all 0.5s;
    padding:5px;
    opacity: ${props => (props.videoMode && props.speakMode) ? 0 : 1};

`

export const PromptSpeakMode = styled.div`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width: 40px;
    height: 30px;
    transition: all 0.5s;
`

export const EachEmptyCategoryTitleInactive = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    color: rgba(26, 59, 103, 0.5);

`

export const EachEmptyCategoryTitleSub = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:13px;

`



export const EachEmptyCategory = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:200px;
    height:60px;
    padding:20px;
    border-radius:50px;
    border:1px solid ${props => props.$active ? 'rgba(77, 192, 233, 1);' : 'rgba(26, 59, 103, 0.1)'};
    gap:10px;
    background: ${props => props.$active ? 'rgba(77, 192, 233, 1);' : '#f9f9f9' };
    transition: all 0.3s;
    transform: scale(1.0);

    &:hover {
        border: 1px solid ${props => props.$active ? 'rgba(77, 192, 233, 1)' : '#a9a9a9'};
        transform: scale(1.02);
    }

    &:active {
        transform: scale(1.0);
    }
`


export const EachEmptyCategoryExtend = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:60px;
    padding:20px;
    border-radius:50px;
    border:1px solid ${props => props.$active ? 'rgba(77, 192, 233, 1);' : 'rgba(26, 59, 103, 0.1)'};
    gap:10px;
    background: ${props => props.$active ? 'rgba(77, 192, 233, 1);' : '#f9f9f9' };
    transition: all 0.3s;
    transform: scale(1.0);

    &:hover {
        border: 1px solid ${props => props.$active ? 'rgba(77, 192, 233, 1)' : '#a9a9a9'};
        transform: scale(1.02);
    }

    &:active {
        transform: scale(1.0);
    }
`

export const EachEmptyCategoryAgain = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:200px;
    height:60px;
    padding:20px;
    border-radius:50px;
    border:1px solid ${props => props.$active ? 'rgba(77, 192, 233, 1);' : 'rgba(26, 59, 103, 0.1)'};
    gap:10px;
    background: ${props => props.$active ? 'rgba(77, 192, 233, 1);' : '#f9f9f9' };
    transition: all 0.3s;
`


export const LineBreaker = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:50px;
    height:5px;
    width:5px;
    background: rgb(26, 55, 100);
    flex-grow:0;
    flex-shrink:0;
    opacity:0.5;
`


export const IconContainer = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-top-right-radius:10px;
    border-bottom-right-radius:10px;
    flex-grow:0;
    flex-shrink:0;
    height:25px;
    width:25px;
    cursor:pointer;
`

export const InnerSectionTool = styled.div`
    display:flex;
    justify-content:space-between;
    padding:20px;
    width:100%;
`

export const HeadingOverallNamer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    gap:10px;
    width:100%;
    padding-bottom:20px;
` 

export const HeadingNamer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
`

export const IconContainerScale = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-top-right-radius:10px;
    border-bottom-right-radius:10px;
    flex-grow:0;
    flex-shrink:0;
    height:25px;
    width:25px;
    transition: all 0.3s;
    transform: scale(1.0);
    cursor:pointer;

    &:hover {
        transform: scale(1.1);
    }

    &:active {
        transform: scale(1.0);
    }

`

export const TagTitle = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    color:#a9a9a9;
    transition: all 0.3s;

`


export const TagTitleOther = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    color: rgb(26, 55, 100);
    transition: all 0.1s;
    gap:5px;
`

export const BottomTextPleaseWait = styled.span`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:20px;
    color: rgba(26, 55, 100, 0.5);
    padding:50px;
    width:500px;
`



export const TagButton = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    border-radius:25px;
    background:#f9f9f9;
    border:1px solid #e5e5e5;
    cursor:pointer;
    transition: all 0.3s;
    gap: 10px;
`


export const TagButtonOtherMe = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: ${props => props.$active ? 'linear-gradient(90deg, rgba(26, 55, 100, 0.9) 0%, rgba(36, 211, 255, 0.9) 100%)' : '#transparent'};
    color: ${props => props.$active ? '#ffffff' : 'rgb(26, 55, 100)'};
    cursor:pointer;
    transition: all 0.3s;
    font-size:14px;
    padding: 18px 20px;
    width:110px;
    opacity: ${props => props.$active ? '1' : '0.3'};

    &:hover {
        opacity: ${props => props.$active ? '1' : '0.8'};
    }
`


export const TagButtonOtherMeInverse = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: ${props => props.$active ? 'linear-gradient(270deg, rgba(26, 55, 100, 0.9) 0%, rgba(36, 211, 255, 0.9) 100%)' : '#transparent'};
    color: ${props => props.$active ? '#ffffff' : 'rgb(26, 55, 100)'};
    cursor:pointer;
    transition: all 0.3s;
    padding:18px 20px;
    font-size:14px;
    width:110px;
    opacity: ${props => props.$active ? '1' : '0.3'};

    &:hover {
        opacity: ${props => props.$active ? '1' : '0.6'};
    }
`


export const TagButtonOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:10px;
    background: ${props => props.$active ? '#e1e1e1' : '#f1f1f1'};
    cursor:pointer;
    transition: all 0.3s;
    overflow:hidden;
    padding:10px;
    gap:10px;
    opacity: ${props => props.$active ? '1.0' : '0.5'};
`

export const TagButtonGroup = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    position:relative;
    cursor:pointer;

    &:hover > ${TagButton} {
        border: 1px solid rgb(26, 55, 100);
        background: #e5e5e5;
    }

    &:hover > ${TagTitle} {
        color: rgb(26, 55, 100);
    }

    &:hover > ${TagButtonOther} {
        background: #e1e1e1;
    }
`


export const ListOfAssistants = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    flex-grow:0;
    flex-shrink:0;
    width:150%;
`



export const ListOfModels = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    gap:10px;
    flex-grow:0;
    flex-shrink:0;
    width:100%;
    overflow:scroll;
    height:100%;
`


export const ListOfRulebooks = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    flex-grow:0;
    flex-shrink:0;
    width:100%;
`

export const CategoryMenuBottomCentered = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:50%;
    width:100%;
`

export const SayActive = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(88, 192, 164);
    border-radius:20px;
    padding:7px 12px;
    color:#ffffff;
`


export const SayActiveSmall = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(88, 192, 164);
    border-radius:20px;
    padding:4px 10px;
    color:#ffffff;
    font-size: 14px;
    margin-left:10px;
`

export const AlignLeft = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    gap:5px;
`


export const AccountDetailGroup = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
    align-items:flex-end;
    align-content:center;
    gap: 5px;
    position:relative;
`

export const HighlightRole = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    background: rgba(77, 192, 233, 0.1);
    border-radius:30px;
    font-size:13px;
    font-family: newFontFaceBold;
`

export const HighlightRoleGroup = styled.div`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:150px;
`



export const AnotherDropDown = styled.div`
    display:${props => props.$active ? 'flex' : 'none'};
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:absolute;
    top:70px;
    right:0px;
    width:350px;
    border-radius:10px;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.15) 0px 7px 20px 0px, rgba(0, 0, 0, 0.15) 0px 3px 20px 0px;
    z-index:10000;
    gap:10px;
    padding:10px;
    overflow:hidden;
`



export const AnotherDropDownMe = styled.div`
    display:${props => props.$active ? 'flex' : 'none'};
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    position:absolute;
    top:70px;
    right:0px;
    width:350px;
    border-radius:10px;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.15) 0px 7px 20px 0px, rgba(0, 0, 0, 0.15) 0px 3px 20px 0px;
    z-index:1000000;
    gap:10px;
    padding:10px;
    overflow:scroll;
    max-height:400px;
`


export const AnotherDropDownSmaller = styled.div`
    display:${props => props.$active ? 'flex' : 'none'};
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:absolute;
    top:70px;
    right:0px;
    width:250px;
    border-radius:10px;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.15) 0px 7px 20px 0px, rgba(0, 0, 0, 0.15) 0px 3px 20px 0px;
    z-index:10000;
    gap:10px;
    padding:10px;
`

export const DisplayRightNow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
`

export const GroupLeftSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    flex-grow:0;
    flex-shrink:0;
`


export const GroupRightSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
    padding-left:20px;
    flex-grow:1;
    flex-shrink:1;
`


export const SwitchesAtTop = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items:center;
    align-content:center;
`



export const EachOptionRow = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:220px;
    height:300px;
    border-radius:20px;
    padding:20px;
    overflow:hidden;
    background: ${props => props.$active ? 'rgba(49, 106, 183, 0.5)' : '#EDF1F5'};
    cursor:pointer;
    gap: 10px;
    transition: all 0.5s;

    &:hover {
        background: rgba(49, 106, 183, 0.5);
    }

`



export const EachRuleBookOptionToShow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    border-radius:5px;
    padding:10px;
    background: ${props => props.$active ? 'rgba(77, 192, 233, 0.3)' : '#f9f9f9'};
    cursor:pointer;
    gap: 10px;
`


export const EachModelRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    border-radius:5px;
    padding:10px;
    background: rgba(237,241,245,0.5);
    gap: 10px;
`

export const InternalGroup = styled.div`
    display:flex;
    flex-direction:row;
    flex-direction:space-between;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px 15px;
    padding-right:5px;
    gap:10px;
`

export const OverallButton = styled.div`
    display:flex;
    flex-direction:row;
    flex-direction:space-between;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:${props => props.$active ? '#f1f1f1' : 'none'};
    color: #000000;
    transition: all 0.6s;
    gap:10px;
    border-radius:10px;
    border:1px solid transparent;
    cursor:pointer;
    position:relative;

    &:hover {
        background: #f1f1f1;
    }
`


export const IconAnotherWrapper = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    padding-left:0px;
    cursor:pointer;
`


export const IconAnotherWrapperThis = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:5px;
    cursor:pointer;
    position:relative;
    top:6px;
`

export const ListOfStaffWrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
`


export const IconAnotherWrapperAnother = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    cursor:pointer;
    transition: all 0.3s;
    background: transparent;
    border-radius:30px;

    opacity:0.8;
    transform: scale(1.0)
    cursor:pointer;

    &:hover {
        opacity:1.0;
        transform: scale(1.1);
    }

    &:active {
        opacity:1.0;
        transform: scale(1.0);
    }
`


export const IconAnotherWrapperAnotherNoScale = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    cursor:pointer;
    transition: all 0.3s;
    background: transparent;
    border-radius:30px;

    opacity:0.6;
    transform: scale(1.0)
    cursor:pointer;

    &:hover {
        opacity:1.0;
    }

    &:active {
        opacity:1.0;
    }
`




export const TextName = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start ;
    align-items:center;
    align-content:center;
    padding:15px;
    text-align:left;
    font-size:14px;
    background: rgba(77, 192, 233, 0.1);
    border-radius:30px;
    font-family: newFontFaceBold;
`


export const ButtonBottom = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-top:20px;
    width:100%;
`

export const OtherSmallText = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color:#a9a9a9;
    font-size:14px;
    transition: all 0.3s;
    cursor:pointer;

    &:hover {
        color: #000000;
    }
`

export const OverallItem = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:rgba(255,255,255,0.8);
    padding:15px;
    gap:15px;
    border-radius:50px;
`

export const OverallItemsOption = styled(Link)`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: ${props => props.$active ? 'rgba(36, 211, 255, 0.3)' : 'transparent'};
    padding:20px 40px;
    border-radius:30px;
    cursor:pointer;
    transition: all 0.3s;
    text-decoration:none;
    color:#000000;
    transform: scale(1);

    &:hover {
        background: rgba(36, 211, 255, 0.3);
        transform: scale(1.05)
    }

    &:active {
        background: rgba(36, 211, 255, 0.3);
        transform: scale(1.00)
    }
`

export const SkeletonContainer = styled.div`
    display:flex;
    flex-direction: ${(props) => props.direction || "row"};
    justify-content:center;
    align-items:center;
    width: ${(props) => props.width || "auto"};
    min-width: ${(props) => props.minwidth || "auto"};
    height: ${(props) => props.height || "auto"};
    min-height: ${(props) => props.minheight || "auto"};
    gap: ${(props) => props.gap || "10px"};
    padding: ${(props) => props.paddingOverall || "0px"};
    padding-top: ${(props) => props.paddingTop || "0px"};
    flex-wrap: ${(props) => props.wrap || "nowrap"};
    border-radius: ${(props) => props.borderRadius || "0px"};
`


export const SkeletonBox = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    flex-shrink:0;
    flex-grow:0;
    background: linear-gradient(90deg, #ffffff 25%, #f4f4f4 50%, #ffffff 75%);
    background-size: 200% 100%;
    animation: ${shimmer} 3s infinite;
    width: ${(props) => props.width || "100%"};
    height: ${(props) => props.height || "16px"};
    border-radius: ${(props) => props.borderRadius || "4px"};
`;

// -------------
// STYLES
// -------------

export const RightColumnInner = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    height:100%;
    border-radius:30px;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
`

export const UnderDeck = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    overflow:scroll;
`

export const ClientTargetMessaging = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    max-width:700px;
    color: #1A3B67;
    padding:20px;
    padding-bottom:60px;
`

export const EachDropDownChoice = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    color:#000000;
`

export const EachDropDownChoiceTags = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    color:#000000;
    padding:5px 20px;
    z-index:300;
`





export const GeneratePDFButtonInnerLoading = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgba(77, 192, 233, 0.1);
    width:100%;
    height:70px;
    border-radius:10px;
    color:#000000;
    transition: all 0.3s;
    padding:10px;
    transform:scale(0.95);
    transition: all 0.3s;
    gap:10px;

    &:hover {
        background: rgba(77, 192, 233, 0.6);
        transform:scale(1.00);
    }

    &:active {
        transform:scale(0.95);
    }
`


export const ButtonLinkDownload = styled(PDFDownloadLink)`
    box-sizing:border-box;
    outline:0;
    cursor:pointer;
    display:flex;
    flex-direction:row;
    text-decoration:none;
    width:100%;
    height:100%;
`

export const GeneratePDFButtonInnerReady = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(88, 192, 164);
    width:100%;
    height:70px;
    border-radius:10px;
    color:#ffffff;
    transition: all 0.3s;
    padding:10px;
    transform:scale(0.95);
    transition: all 0.3s;
    gap:10px;

    &:hover {
        transform:scale(1.00);
    }

    &:active {
        transform:scale(0.95);
    }
`

export const GeneratePDFButtonInner = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgba(77, 192, 233, 0.1);
    width:100%;
    height:70px;
    border-radius:10px;
    color:#000000;
    transition: all 0.3s;
    padding:10px;
    transform:scale(0.95);
    transition: all 0.3s;
    gap: 10px;

    &:hover {
        background: rgba(77, 192, 233, 0.6);
        transform:scale(1.00);
    }

    &:active {
        transform:scale(0.95);
    }
`

export const EachDropDownChoiceInner = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: ${props => {
        if (!props.$active) return 'none';
        return `rgba(88, 192, 164, 0.2)`;
    }};
    width: 100%;
    height: 70px;
    border-radius: 10px;
    color: #000000;
    transition: all 0.3s;
    padding: 10px;

    &:hover {
        background: rgba(88, 192, 164, 0.1);
    }
`;


export const EachDropDownChoiceInnerMe = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: transparent;
    width: 100%;
    height: 70px;
    border-radius: 10px;
    color: #000000;
    transition: all 0.3s;
    padding: 10px;
    gap:10px;

    &:hover {
        background: #f9f9f9;
    }
`;


export const EachDropDownChoiceInnerVersions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: ${props => {
        if (!props.$active) return 'none';
        if (props.$stage === 'complete') return 'rgba(88, 192, 164, 0.2)';
        if (props.$stage === 'processing') return 'rgba(77, 192, 233, 0.1)';
        return 'rgba(255, 229, 229, 1)';
    }};
    width: 100%;
    height: 70px;
    border-radius: 10px;
    color: #000000;
    transition: all 0.3s;
    padding: 10px;

    &:hover {
        background: ${props => {
            if (props.$stage === 'complete') return 'rgba(88, 192, 164, 0.2)';
            if (props.$stage === 'processing') return 'rgba(77, 192, 233, 0.1)';
            return 'rgba(255, 229, 229, 1)';
        }};
    }
`;

export const LeftAlign = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    background:none;
    gap:5px;
    width:100%;
    color:#000000;
`

export const LeftAlignRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    background:none;
    gap:20px;
    height:100%;
`

export const LastItem = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:80%;
    height:400px;
    background:rgba(255,255,255,0.8);
    border-radius:20px;
    overflow:hidden;
    position:relative;

    @media (max-width: 599px) {
        width:100%;
        border-radius:0px;
    }

`

export const LastItemCover = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    overflow:hidden;
    padding-top:0px;
    width:100%;
    padding-bottom:50px;

`

export const DocumentReel = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    padding:30px;
    flex-wrap:wrap;
`
export const DocumentReelEach = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    padding:10px;
    border-radius:30px;
    background: #58C0A4;
    transform: scale(1);
    transition: all 0.2s;

    &:hover {
        transform: scale(1.02);
    }
`
export const DocumentReelEachIcon = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
`
export const DocumentReelEachText = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color:#ffffff;
    font-size:14px;
    padding-top:3px;
`


export const EditOnRight = styled.button`
    display:none;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:absolute;
    right:-40px;
    transition: all 0.2s;
    width:40px;
    height:100px;
    opacity: 0.5;
    cursor:pointer;
    outline:none;
    border:none;
    background:none;

    &:hover {
        display:flex;
        opacity: 1.0;
    }

`

export const AlignToRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    gap:30px;
`

export const BottomOfNumberFocus = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:flex-end;
    align-content:flex-end;
    padding:20px;
    padding-top:0px;
`

export const SectionNext = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    box-sizing:border-box;
    height:100%;
    padding:50px;
    
`

export const RuleCounter = styled.div`
     display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:25px;
    color:#000000;
    font-size:14px;
    padding:10px;
    width:100px;
    font-family: ${props => props.$active ? 'newFontFaceBold' : 'newFontFace'};
`

export const RowAlignment = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:20px;
    width:100%;
`

export const OverallGroupRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
`

export const OverallGroupAnother = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-bottom:5px;
`


export const OverallGroup = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:center;
    padding-bottom:15px;
    width:100%;
    
`

export const OverallGroupSimple = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    padding-bottom:15px;
    width:100%;
    
`


export const OverallGroupTryAgain = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-bottom:15px;
    width:500px;
    
`


export const InnerSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:20px;
`


export const OverallGroupTryAgainToDo = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: #ffffff;
    border-radius:30px;
    box-shadow: rgba(60, 66, 87, 0.06) 0px 7px 10px 0px, rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
    overflow:hidden;

    
`


export const OverallGroupSmall = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:center;
    width:200px;
    padding-bottom:15px;
    
`


export const OverallGroupAlign = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
    padding-bottom:10px;
    
`

export const OverallGroupAlignAnother = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
    border:1px dashed ${props => !props.active ? '#d5d5d5' : 'transparent'};
    border-radius: 10px;
    background: ${props => !props.active ? '#f9f9f9' : 'transparent'};
`



export const SwitchOptionDisplay = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
`


export const OverallGroupOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    padding:10px;
    overflow:scroll;
    gap:30px;
    flex-wrap: wrap;
`

export const IconRightGrouped = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: center;
    align-content:center;
    align-items:center;
    position:absolute;
    height:0px;
    width:0px;
    right:25px;
    transition: all 0.3s;
`


export const IconRightGroupedHidden = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: center;
    align-content:center;
    align-items:center;
    position:absolute;
    height:0px;
    width:0px;
    right:25px;
    transition: all 0.3s;
    opacity:0;
`


export const RuleGroupInner = styled(Link)`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:#ffffff;
    border-radius:10px;
    padding:0px;
    transition: all 0.3s;
    cursor:pointer;
    text-decoration:none;
    position:relative;
    width: 100%;
    
    &:hover {
        box-shadow: rgba(60, 66, 87, 0.06) 0px 7px 10px 0px, rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
        transform: scale(1.01);

        & > ${IconRightGrouped} {
            right:20px;
        }
    }
    
    &:active {
        transform: scale(1);
    }

    
`



export const TopBarOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%; 
    height:60px;
    padding:20px;
    padding-bottom:10px;
    background:#ffffff;
    text-decoration:none;
    border-radius:10px;

`



export const RuleGroup = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:10px;
    padding:0px;
    transition: all 0.3s;
    cursor:pointer;
    text-decoration:none;
    position:relative;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 0px 14px 0px, rgba(0, 0, 0, 0.12) 0px 0px 6px 0px;
    
    /* Default width (greater than 600px) */
    width: calc((100% / 3) - 20px);

    /* Between 300px and 600px */
    @media (min-width: 900px) and (max-width: 1200px) {
        width: calc((100% / 2) - 20px);
    }

    /* Less than 300px */
    @media (max-width: 899px) {
        width: 100%;
    }
    
    &:hover {
        box-shadow: rgba(60, 66, 87, 0.06) 0px 7px 10px 0px, rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
        transform: scale(1.01);

        & > ${RuleGroupInner} > ${TopBarOther} > ${IconRightGrouped} {
            right:20px;
        }
    }
    
    &:active {
        transform: scale(1);
    }

    
`

export const ButtonAdd = styled.div`
    display:flex;
    flex-direction: row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:rgb(77, 192, 233);
    width:30px;
    height:30px;
    border-radius:10px;
    z-index:10000;
    cursor:pointer;

    &:hover {
        transform: scale(1.01);
    }

    &:active {
        transform: scale(0.99);
    }
`

export const LeftColumn = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    height:100%;
    padding-bottom:20px;
`

export const EachRulebook = styled.div`
    display:flex;
    flex-direction: row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    border-radius:30px;
    background: #ADD8E6;
  

`

export const BothColumns = styled.div`
    width:100%;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:flex-start;
    padding-top:50px;
    

`

export const LeftColumnInner = styled.div`
    display:flex;
    flex-direction:column;
    flex-shrink:0;
    flex-grow:0;
    width:400px;
    height:100%;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    padding-right:50px;
`

export const BenefitTitle = styled.div`
    font-family: newFontFace, Arial, sans-serif;
    height:80px;
    box-sizing:border-box;
    font-size:20px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
`

export const OutsideOption = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    border:1px dashed #d5d5d5;
    border-radius:10px;
    padding:10px;
    width: 100%;
    gap:10px;
    overflow-x:scroll;
`

export const OutsideOptionRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border:1px solid #d5d5d5;
    border-radius:10px;
    padding:10px;
    gap:10px;
`

export const BenefitTitleSmall = styled.div`
    font-family: newFontFace, Arial, sans-serif;
    height:80px;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    cursor:pointer;
    opacity:${props => props.active ? '1.0' : '0.8'};
    text-decoration: ${props => props.active ? 'underline' : 'none'};
    transition: all 0.2s;

    &:hover {
        opacity:1.0;
    }
`




export const ClientHeading = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    color: #1A3B67;
    transition: all 0.2s;
    padding:20px;
`

export const CustomerSubHeading = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:center;
    cursor:pointer;
    color: #6C87AE;
    transition: all 0.2s;
    padding-top:10px;
    padding-bottom:10px;

    

    &:hover {
        opacity:1.0;
    }
`

export const CustomerCommentQuote = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: #6C87AE;
    transition: all 0.2s;
    padding-top:5px;
    padding-bottom:5px;
    width:100%;
`



export const CustomerCommentTitle = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: #000000;
    transition: all 0.2s;
    padding-top:5px;
    padding-bottom:5px;
    width:100%;
`

export const MainSubHeading = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: rgba(0,0,0,0.8);
    transition: all 0.2s;
    padding-top:10px;
    padding-bottom:10px;

    

    &:hover {
        opacity:1.0;
    }
`


export const MainContactShow = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
`

export const LeftColumnMiddle = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    gap:10px;
`

export const LeftColumnMiddleEnd = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    gap:10px;
    padding:10px;
`

export const MainSubHeadingLarger = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:16px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: rgba(0,0,0,0.8);
    transition: all 0.2s;
    border-radius:100px;

    

    &:hover {
        opacity:1.0;
    }
`



export const MainSubHeadingBold = styled.span`
    font-family: newFontFaceBold, Arial, sans-serif;
    box-sizing:border-box;
    font-size:20px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: rgba(0,0,0,0.8);
    transition: all 0.2s;
    padding-bottom:10px;

    

    &:hover {
        opacity:1.0;
    }
`


export const MainSubHeadingTop = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    text-align:left;
    cursor:pointer;
    color: #6C87AE;
    transition: all 0.2s;
    padding-top:10px;
    padding-bottom:50px;

    

    &:hover {
        opacity:1.0;
    }
`


export const MainSubHeadingList = styled.ul`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    text-align:left;
    color: #6C87AE;
    transition: all 0.2s;
`



export const MainSubHeadingListItem = styled.ul`
    font-family: newFontFace, Arial, sans-serif;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    flex-direction:row;
    gap:10px;
    justify-content:flex-start;
    align-content:flex-start;
    align-items:center;
`


export const MainSubHeadingLeft = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    height:80px;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    cursor:pointer;
    color: rgba(26, 59, 103, 0.5);
    opacity:${props => props.active ? '1.0' : '0.8'};
    text-decoration: ${props => props.active ? 'underline' : 'none'};
    transition: all 0.2s;
    padding-top:50px;
    padding-bottom:50px;
    text-align:left;
    flex: 1;

    &:hover {
        opacity:1.0;
    }
`


export const MainSubHeadingLeftAgain = styled.span`
    font-family: newFontFace, Arial, sans-serif;
    height:80px;
    box-sizing:border-box;
    font-size:14px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    cursor:pointer;
    color: rgba(26, 59, 103, 0.5);
    opacity:${props => props.active ? '1.0' : '0.8'};
    text-decoration: ${props => props.active ? 'underline' : 'none'};
    transition: all 0.2s;
    padding-top:50px;
    padding-bottom:50px;
    text-align:right;
    width:60px;

    &:hover {
        opacity:1.0;
    }
`

export const BothSides = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    padding-left:20px;
    padding-right:20px;
    width:100%;
`

export const PictureFull = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    height:80px;
`

export const CenterWrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width:100%;
`

export const Heading = styled.div`
    font-size:25px;
    font-weight:200;
    color: #000000;
    padding:25px;
    display:flex;
    justify-content: center;
    align-items: center;
    text-decoration:none;
    flex:1;
`


export const FormField = styled.div`
    padding:10px 0px;
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    gap: 10px;
    
`

export const baseDescripter = styled.span`
    display:flex;
    justify-content:center;
    align-items:center;
    justify-content;
    color:#a9a9a9a9;
    font-size:17px;
    padding-left:10px;
    font-weight:bold;
    padding-bottom:2px;
`

export const FormFieldRow = styled.div`
    display:flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    gap: 10px;
`


export const ContainerContent = styled.form`
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content:center;
    z-index: 1000000;
    height:100vh;
    min-height:700px;

`

export const ImageLocation = styled.div`
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content:center; 
    width:100%;
    height:100%;
`

export const ErrorFieldOuter = styled.div`
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    width:100%;
`

export const ErrorField = styled.div`
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start;
    width:100%;
    padding:10px;
    font-size:14px;
    border-radius:50px;
    list-style:none;
    border: 1px dashed #F67280;
    background: #ffecee;
    margin-bottom:20px;


    & > li {
        color: red;
        margin-left:5px;
        color:red;
        text-align:center;
        width:100%;

    }
`


export const BottomSection = styled.div`
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    flex-wrap: nowrap;
    box-sizing: border-box;
`


export const ContentElement = styled.div`
    box-sizing: border-box;
    border:none;
    width: 350px;
    padding:25px;
`


export const FieldTitleLink = styled(Link)`
    justify-content: space-between;
    align-items: flex-start;
    align-content: space-between;
    text-align:right;
    text-decoration: none;
    font-weight:400;
    color:#12AFF0;
    padding-top:30px;
    font-size:14px;
    font-family:newFontFace;

    &:hover {
        text-decoration: underline;
    }
`


export const Button = styled.button`
    color:#ffffff;
    box-sizing:border-box;
    font-size:15px;
    padding: 15px 0px;
    outline:0;
    margin-top:20px;
    cursor:pointer;
    transition: all 0.5s;
    width:100%;
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:10px;
    border: 1px solid transparent;
    box-shadow: transparent 0px 7px 14px 0px, transparent 0px 3px 6px 0px;
    font-family:newFontFace;
    
    opacity: ${props => props.disabled ? '0.3' : '1.0'}
    


    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }


`


export const TopBar = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-content:center;
    align-items:center;
    height: 70px;
    width:100%;
    background:#ffffff;
    padding:0px 20px;
    border-bottom:1px solid #D5D5D5;
    flex-grow:0;
    flex-shrink:0;
`


export const SecondBar = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-content:center;
    align-items:center;
    height: 70px;
    width:100%;
    background:#ffffff;
    padding:0px 20px;
    border-bottom:1px solid #D5D5D5;
    padding-right:33px;
     flex-grow:0;
    flex-shrink:0;
`


export const SelectorBar = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-content:center;
    align-items:center;
    height: 70px;
    width:100%;
    padding:0px 20px;
    flex-grow:0;
    flex-shrink:0;
`


export const ThirdBar = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-content:center;
    align-items:center;
    height: 70px;
    width:100%;
    padding:10px 20px;
     flex-grow:0;
    flex-shrink:0;
`



export const TopBarSelector = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    align-content:center;
    align-items:center;
    width:100%;
    height:100px;
    padding:20px 20px;
    flex-grow:0;
    flex-shrink:0;
    padding-top:60px;
`






export const LeftHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: center;
    align-content:center;
    align-items:center;
    color: rgb(26, 55, 100);
    font-size: 23px;
`


export const RightButtons = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: center;
    align-content:center;
    align-items:center;
    gap: 20px;
`

export const RightButtonsMiddle = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: flex-start;
    align-content:flex-start;
    align-items:flex-start;
    gap: 20px;
    border:1px solid #e5e5e5;
    border-radius:10px;
    margin-top:20px;
    padding-left:20px;
    padding-right:20px;
`

export const RightButtonsDown = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-content:center;
    align-items:center;
    gap: 20px;
    padding-bottom:30px;
    padding-top:130px;
`



export const ButtonItem = styled.button`
    color:#ffffff;
    box-sizing:border-box;
    font-size:13px;
    outline:0;
    cursor:pointer;
    transition: all 0.5s;
    background:${props => {
        return props.sticky ? '#4CD964' : 'none'}
    };
    border-radius:5px;
    border: 1px solid transparent;

    box-shadow: ${props => {
        if (props.sticky) {
            return 'rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;'
        } else {
            return 'transparent 0px 7px 14px 0px, transparent 0px 3px 6px 0px;'
        }
    }};
    
    
    font-weight:bold;



`






export const AccountGroup = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    padding:15px;
    border-radius:100px;
    transition: all 0.5s;
    transform: ${props => props.$active ? 'scale(0.95)' : 'scale(1)'};
    cursor:pointer;
    background: ${props => props.$active ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.2)'};
    border: ${props => props.$active ? '1px solid transparent' : '1px solid #D5d5d5'};


    &:hover {
        background: ${props => props.$active ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.4)'};
        transform: scale(0.95);
    }

    &:active {
        background: rgba(255,255,255,0.2);
        transform: scale(0.90);
        box-shadow: rgba(60, 66, 87, 0.12) 0px 7px 10px 0px, rgba(0, 0, 0, 0.12) 0px 3px 10px 0px;
    }
    
`



export const MenuBoxLink = styled.div`
    display: flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    width:100%;
    flex-grow:0;
    flex-shrink:0;
    text-decoration:none;
    border-top:1px solid #e5e5e5;
`



export const MenuBoxInnerSymbol = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:45px;
    height:45px;
    border-radius:50px;
    flex-grow:0;
    flex-shrink:0;
`


export const MenuBoxInnerSymbolOther = styled.div`
    display:flex;
    justify-content:flex-end;
    align-items:center;
    width:50px;
    height:50px;
    border-radius:50px;
    flex-grow:0;
    flex-shrink:0;
    transition: all 0.2s;
`

export const MenuBoxTitle = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-size:13px;
    font-weight:400;
    color:#090909;
    text-decoration:none;

`

export const MenuBoxLeft = styled.span`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;

`

export const MenuBoxTitleTop = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    font-size:16px;
    color:#090909;
    text-decoration:none;
    padding:15px;
    width:100%;
    font-weight:bold;

`


export const MenuBoxTitleBottom = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-size:10px;
    color:#a9a9a9;
    text-decoration:none;
    padding:15px;
    width:100%;
    border-top:1px solid #e5e5e5;

`




export const MenuBoxSmall= styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    font-size:10px;
    font-weight:400;
    color:#090909;
    text-decoration:none;
    padding-top:5px;
`


export const MenuBoxRead = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    font-size:10px;
    font-weight:400;
    color:rgb(255, 92, 0);
    text-decoration:none;
    padding-left:20px;

`

export const MenuBoxInner = styled.div`
    display:flex;
    justify-content:space-between;
    align-content:center;
    align-items:center;
    width:100%;
    height:100%;
    text-decoration:none;
    padding:10px;

    &:hover {
        background:#f9f9f9;
    }

    &:hover > ${MenuBoxInnerSymbolOther} {
        transform: translateX(-10px);
    }

    &:active > ${MenuBoxInnerSymbolOther} {
        transform: translateX(-5px);
        transition: all 0.1s;
    }
`




export const NotificationPanel = styled.div`
    display:${props => props.show ? `flex` : `none`};
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    position:absolute;
    top: 75px;
    right: 0;
    width:250px;
    min-height:50px;
    max-height:calc(100vh - 80px);
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.24) 0px 7px 15px 0px, rgba(0, 0, 0, 0.24) 0px 3px 15px 0px;
    right:15px;
    border-radius:10px;
    z-index:1000000;

`


export const MiniCounterOuter = styled.div`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:0;
    height:0;
    position:relative;
`

export const MiniCounterInner = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:absolute;
    top:-29px;
    right:-22px;
    width:25px;
    height:25px;
    border-radius:100px;
    background:#FF5C00;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    
`





export const BarButton = styled.button`
    color:#ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 0px;
    outline:0;
    cursor:pointer;
    transition: all 0.5s;
    width:100%;
    width:45px;
    height:45px;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: #4DC0E9;
    border-radius:100px;
    border: 1px solid transparent;
    box-shadow: transparent 0px 7px 14px 0px, transparent 0px 3px 6px 0px;
    
    opacity: ${props => props.disabled ? '0.3' : '1.0'}
    
    font-weight:bold;

    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }


`


export const ButtonFull = styled.button`
    color:#ffffff;
    box-sizing:border-box;
    font-size:14px;
    padding: 10px 0px;
    outline:0;
    cursor:pointer;
    transition: all 0.5s;
    width:100%;
    height:45px;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: #4DC0E9;
    border-radius:100px;
    border: 1px solid transparent;
    box-shadow: transparent 0px 7px 14px 0px, transparent 0px 3px 6px 0px;
    
    opacity: ${props => props.disabled ? '0.3' : '1.0'}
    
    font-weight:bold;

    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }


`


export const LeftItemsBorder = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    border-radius:30px;
   
    border: 1px solid rgba(0, 0, 0, 0.12);
    overflow: hidden;
    height:40px;
`

export const LeftItems = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
`



export const leftButton = styled(Link)`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:10px;
    padding:10px;
    border:1px solid #d5d5d5;

    cursor:pointer;
    transition: all 0.5s;
    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }
`



export const leftButtonFunction = styled.button`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:10px;
    padding:10px;
    border:1px solid #d5d5d5;

    cursor:pointer;
    transition: all 0.5s;
    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }
`


export const LeftTitle = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:23px;
    padding-left:10px;
    color: rgb(26, 55, 100);
`

export const FrontPageGroup = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
    padding:50px;
    gap:20px;
`

export const LeftTitleOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:13px;
    color: rgb(26, 55, 100);
    padding: 10px 00px;
    text-align:left;
`


export const LeftTitleOtherMe = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:15px;
    color: #a9a9a9;
    padding: 10px 00px;
    text-align:center;
`

export const LeftTitleOtherSmaller = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:15px;
    color: rgb(26, 55, 100);
    padding:0px;
    padding-bottom: 10px;
     width:250px;
`


export const LeftTitleOtherTop = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:15px;
    color: rgb(26, 55, 100);
    padding: 10px 25px;
    width:100%;
    
`

export const LeftTitleOtherTopNext = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:15px;
    color: rgb(26, 55, 100);
    width:100%;
    
`




export const LeftTitleLarger = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:16px;
    color: rgb(26, 55, 100);
`



export const LeftTitleSmall = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:10px;
    color: rgb(26, 55, 100);
`


export const LeftTitleSmallRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:13px;
    color: rgb(26, 55, 100);
    padding-top:15px;
    padding-bottom:15px;
    color:#d5d5d5;
`

export const ListOfFiles = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    list-style-type: none;
    padding: 0; /* Optional: removes default padding */
    margin: 0; /* Optional: removes default margin */
    gap:10px;
    width:500px;
`   

export const EachFile = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    padding-bottom:10px;
`
 

export const EachFileInternal = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    border-radius:10px;
    background:rgba(77, 192, 233, 0.1);
    padding:15px;
`

export const EachFileText = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:${props => props.align};
    align-items:center;
    align-content:center;
    font-size:13px;
    color:#000000;
    width: ${props => props.setWidth};
`

export const OverallContent = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    height:100%;
    width:100%;
    overflow:hidden;
`


export const OverallContentAnother = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    height:100%;
    width:100%;
    overflow:scroll;
`


export const OverallSection = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    overflow:scroll;
    gap:10px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    overflow:hidden;
    
`


export const AdjustableSectionSettings = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:flex-start;
    width:100%;
    height:100%;
    overflow: scroll;
    padding:10px;
    gap:10px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    
`




export const AdjustableSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    overflow-y: scroll;
    overflow-x: visible !important;
    padding:30px;
    gap:10px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    
`


export const AdjustableSectionNoPad = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    overflow: hidden;
    z-index:10;
    box-sizing: border-box;
    
`


export const AdjustableSectionGoAgain = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:500px;
    height:100%;
    overflow-y: scroll;
    overflow-x: visible !important;
    padding:30px;
    gap:30px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    border-left:1px dashed #d5d5d5;
    flex-grow:0;
    flex-shrink:0;
    
`


export const AdjustableSectionNew = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:300px;
    height:100%;
    overflow-y: scroll;
    overflow-x: visible !important;
    padding:30px;
    gap:30px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    border-left:1px dashed #d5d5d5;
    flex-grow:0;
    flex-shrink:0;
    
`


export const AdjustableSectionRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    padding:30px;
    gap:30px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
   
    
`

export const AdjustableSectionRowMini = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    padding:30px;
    gap:30px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
   
    
`



export const OverallPageScroller = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    overflow:scroll;
    gap:10px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    
    

   
    
`

export const AdjustableSectionRowAgain = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    padding:20px;
    position: relative;
    z-index:10;
    box-sizing: border-box;
    flex:1;
   
    
`

export const InternalText = styled.div`
    display:flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding-left:20px;
`


export const InternalTextOther = styled.div`
    display:flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
`

export const MiniArrowOut = styled.div`
    position: absolute;
    height:0;
    width:0;
    left:-40px;
    top:10px;
    transition: all 0.4s;
    cursor: pointer;
    z-index:1000;
`

export const MiniArrowInner = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-content:center;
    align-items:center;
    height:25px;
    width:25px;
    transition: all 0.6s;
    transform: ${props => props.rotate ? 'rotate(180deg)' : 'rotate(0deg)'};
`

export const LeftArea = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    gap:10px;
`


export const SpecificSection = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    flex-grow:0;
    flex-shrink:0;
    padding:25px;
    gap:15px;
    z-index:5;
    position:absolute;
    top:0;
    right:0;
    z-index:100000;
    transition: all 0.6s;
`

// 

export const SpecificSectionOther = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:0px;
    flex-grow:0;
    flex-shrink:0;
    height:100%;
    overflow: scroll;
    padding:0px;
    padding-left:0px;
    gap:30px;
    position: relative;
    z-index:5;
`



export const MiniTable = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    background:#ffffff;
    flex-grow:0;
    flex-shrink:0;
    border-radius:30px;

`


export const AnotherTable = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    max-width:530px;
    width:100%;
    background:#ffffff;
    border-radius:30px;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
`

export const AnotherTableDash = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    max-width:530px;
    width:100%;
    background:#ffffff;
    border-radius:30px;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
    transition: all 0.2s; 
    cursor:pointer;

    &:hover {
        transform: scale(1.01);
    }
`

export const NumberTable = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:250px;
    background:#ffffff;
    border-radius:30px;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
    transition: all 0.2s; 
    cursor:pointer;

    &:hover {
        transform: scale(1.01);
    }
    

`


export const TableTop = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    padding:20px;
    background:#ffffff;
    cursor:pointer;
    border-radius:30px;
`



export const GroupOnRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
    gap:10px;
    align-items:center;
    align-content:center;
`


export const TableTopNone = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    padding:20px;
    background:#ffffff;
    border-radius:50px;
`

export const TableHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:40px;
    border-bottom:1px solid #e5e5e5;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.02) 0px 4px 4px 0px, rgba(0, 0, 0, 0.02) 0px 2px 4px 0px;

`

export const TableHeadingOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    height:80px;
    flex-grow:0;
    flex-shrink:0;
    border-bottom:1px solid #e5e5e5;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.02) 0px 4px 4px 0px, rgba(0, 0, 0, 0.02) 0px 2px 4px 0px;
    padding:20px;
    
`


export const TableHeadingSep = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    height:60px;
    flex-grow:0;
    flex-shrink:0;
    background:#ffffff;
    padding:20px;
    width:250px;
    
`

export const InternalValues = styled.span`
    display:flex;
    justify-content:center;
    align-items:center;
    padding:7px 15px;
    color: ${ props => props.positive ? 'rgba(88,192,164,1)' : 'rgba(236,120,125,1)'};
    background: ${ props => props.positive ? 'rgba(88,192,164,0.1)' : 'rgb(236,120,125,0.1)'};
    border: 1px solid ${ props => props.positive ? 'rgba(88,192,164,1)' : 'rgba(236,120,125,1)'};
    border-radius:10px;
    font-weight:bold;
`


export const InternalValuesOther = styled.span`
    display:flex;
    justify-content:center;
    align-items:center;
    padding:12px 15px;
    color: #ffffff;
    background: ${ props => props.positive ? 'rgba(88,192,164,1)' : 'rgb(236,120,125,1)'};
    border-radius:10px;
    font-weight:bold;
    box-shadow: #e5e5e5 0px 3px 7px 0px, #e5e5e5 0px 0px 3px 0px;

`


export const TableRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    min-height:50px;
    transition: all 0.1s;
    cursor:pointer;
    padding:15px;
    rgb(26, 55, 100);
    flex-shrink:0;
    flex-grow:0;
    

    &:last-child {
        border-bottom-left-radius:30px;
        border-bottom-right-radius:30px;    
    }

    &:hover {
        background: rgba(77, 192, 233, 0.1);
        transform: scale(1.005)
    }
    
    &:active {
        transform: scale(1)
    }
`

export const TableRowMini = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:50px;
    transition: all 0.1s;
    cursor:pointer;
    padding-left:10px;

    &:hover {
        background: rgba(77, 192, 233, 0.1);
        transform: scale(1.005)
    }
    
    &:active {
        transform: scale(1)
    }
`



export const TableTopLeftHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:17px;
    color:rgb(26, 55, 100);
    
`

export const TableTopRightHeading = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 16px;
    color: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgba(88, 192, 164, 1)';
            case 'negative':
                return 'rgba(236, 120, 125, 1)';
            default:
                return 'rgba(26, 55, 100, 1)';
        }
    }};
    background: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgba(88, 192, 164, 0.1)'; 
            case 'negative':
                return 'rgba(236, 120, 125, 0.1)';
            default:
                return 'transparent'
        }
    }};
    padding:10px;
    border-radius:10px;
    font-weight:bold;

`



export const TableTopRightHeadingBig = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 20px;
    color: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgba(88, 192, 164, 1)';
            case 'negative':
                return 'rgba(236, 120, 125, 1)';
            default:
                return 'rgba(26, 55, 100, 1)';
        }
    }};
    background: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgba(88, 192, 164, 0.1)'; 
            case 'negative':
                return 'rgba(236, 120, 125, 0.1)';
            default:
                return 'transparent'
        }
    }};
    padding:10px;
    border-radius:10px;
    font-weight:bold;

`


export const TableTopRightHeadingBigNumber = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 25px;
    color: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgba(88, 192, 164, 1)';
            case 'negative':
                return 'rgba(236, 120, 125, 1)';
            default:
                return 'rgba(26, 55, 100, 1)';
        }
    }};
    font-weight:bold;

`



// export const EachMiniCell = styled.div`
//     display: flex;
//     flex-direction: row;
//     justify-content: ${props => props.setAlign};
//     align-items: center;
//     align-content: center;
//     width:${props => props.setWidth};
//     font-size:13px;
//     padding:10px;
//     ${props => !props.shrink && ('flex-shrink: 0;')}
   
// `


export const EachMiniCell = styled.div`
    display: flex;
    align-items: ${(props) => props.setAlign || "flex-start"};
    justify-content: ${(props) => props.setAlign || "flex-start"};
    flex-basis: ${(props) => props.setWidth || "auto"};
    flex-grow: ${(props) => (props.shrink ? 1 : 0)};
    flex-shrink: ${(props) => (props.shrink ? 1 : 0)};
    overflow: hidden; /* Prevent content from overflowing */
    text-overflow: ellipsis; /* Add ellipsis for long text */
    font-size:13px;
    height:100%;
    rgb(26, 55, 100);

    ${props => !!props.highlightLeft? `
        background: ${props.highlightColor};
        border-top-left-radius:20px;
        border-bottom-left-radius:20px;
    ` : null}

    ${props => !!props.highlightRight? `
        background: ${props.highlightColor};
        border-top-right-radius:20px;
        border-bottom-right-radius:20px;
    ` : null}


`;

export const circleNo = styled.div`
    display: flex;
    align-items:center;
    align-content:center;
    justify-content:center;
    width:20px;
    height:20px;
    font-size:20px;
    border-radius:100px;
    color: rgb(26, 55, 100);
    padding-right:20px;

`

export const EachMiniHeading = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.setAlign};
    align-items: center;
    align-content: center;
    width:${props => props.setWidth};
    font-size:13px;
    padding:15px;
    color: rgb(26, 55, 100);
     ${props => !props.shrink && ('flex-shrink: 0;')}

`

export const FlagCategory = styled.div`
    display:flex;
    z-index:15px;
    position:relative;
    justify-content:center;
    align-items: center;
    align-content: center;
    padding:5px 10px;
    background: ${props => {
        switch (props.status) {
            case 'high':
                return '#4DC0E9';
            case 'medium':
                return '#ABE1F5';
            case 'low':
                return '#D5D5D5';
            default:
                return '#f9f9f9';
        }
    }};
    color:  ${props => {
        switch (props.status) {
            case 'high':
                return '#ffffff';
            case 'medium':
                return '#ffffff';
            case 'low':
                return '#1A3B67';
            default:
                return '#1A3B67';
        }
    }};
    border-radius:10px;
`


export const ShowHideGrouping = styled.div`
    display:${props => props.show ? 'flex' : 'none'};
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    transition: all 0.3s;
    width:100%;
    border-radius:30px;
    
`

export const Devider = styled.div`
    display:flex;
    justify-content:center;
    align-items: center;
    align-content: center;
    width:100px;
    border-bottom:1px dashed #d5d5d5;
    margin-top:20px;
    margin-bottom:20px;
`


export const OverallRulesGroup = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items: center;
    align-content: center;
    width:100%;
    padding-left:20px;
    padding-right:20px;
    gap: 20px;
`

export const EachRule = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items: center;
    align-content: center;
    padding:20px;
    border-radius:20px;
    background:#ffffff;
    width:100%;
    gap:20px;
    transition: all 0.2s;
    position:relative;

    &:hover {
        transform: scale(1.01);

        & > ${EditOnRight} {
            display:flex;
        }
    }

`


export const EachNumber = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:25px;
    font-weight:bold;
    padding-right:30px;
    padding-left:10px;
`

export const TitleSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:center;
    font-size:13px;
    gap: 10px;
    width:100%;
`

export const TitleTitle = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-weight:bold;
    text-align:left;
`

export const HeadingDescription = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
    font-size:12px;
    color:#a9a9a9;
`



export const TitleDescripionSmall = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
    font-size:11px;
`

export const TitleDescripion = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
`

export const TitleDescripionNew = styled.div`
     display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
    font-size:13px;
`

export const TitleDescripionBold = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
    font-family:newFontFaceBold;
`


export const TitleDescripionBoldOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:left;
    font-family:newFontFaceBold;
    padding-left:10px;
`

export const CategoryLabel = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color:#ffffff;
    background: #1B3A67;
    border-radius:30px;
    padding: 5px 10px;
    font-size:13px;
    width:80px;
`

export const References = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    gap:10px;
    flex-wrap: wrap;
`


export const GroupLeftOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    gap:20px;
`

export const GroupLeft = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
`

export const GroupRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    gap:10px;
    flex-shrink:0;
    flex-grow:0;
    width:200px;
`


export const StartRef = styled.div`
    display:flex;
    flex-direction: row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: rgb(77, 192, 233);
    font-size:10px;
`

export const EachRef = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:5px 10px;
    background: #ABE1F5;
    color: #1A3B67;
    border-radius:20px;
    font-size:10px;
`

export const Importance = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:80px;
    padding:5px 10px;
    background: ${props => {
        switch (props.status) {
            case 'high':
                return '#4DC0E9';
            case 'medium':
                return '#ABE1F5';
            case 'low':
                return '#D5D5D5';
            default:
                return '#f9f9f9';
        }
    }};
    color:  ${props => {
        switch (props.status) {
            case 'high':
                return '#ffffff';
            case 'medium':
                return '#1A3B67';
            case 'low':
                return '#1A3B67';
            default:
                return '#1A3B67';
        }
    }};
    border-radius:30px;
    font-size:13px;
    position:relative;
    z-index:5;
`


export const GroupCol = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-left:20px;
`

export const GroupColLabelCategory = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-bottom:5px;
    font-size:10px;
    color: rgb(27, 58, 103);
`

export const GroupColLabelImportance = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-bottom:5px;
    font-size:10px;
    color: rgb(27, 58, 103);

`


export const BottomBarOther = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    padding:20px;
    height:60px;
    width:100%;
    color: rgba(26, 55, 100, 0.6);
    font-size:13px;
    
`


export const TopBarOtherLeft = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    font-size:16px;
    font-weight:bold;
    color: rgb(26, 55, 100);
`

export const TopBarOtherRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    font-size:16px;
    color: rgb(77, 192, 233);
    background: rgba(77, 192, 233, 0.1);
    border-radius:30px;
    padding:10px;
    font-weight:bold;
    flex-shrink:0;
    flex-grow:0;

`

export const SettingsRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    gap:30px;
    width:100%;
`

export const SettingsElement = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    gap:10px;
    width:100%;
`



export const TextGray = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    color: #a9a9a9;
    font-size:13px;
`

export const SettingsBox = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    gap:10px;
`

export const MiniHeading = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:15px;
    font-family: newFontFaceBold;
`

export const SettingsTitlesRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
`

export const PlanInputContainer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    background: #F8FAFC;
    border-radius:20px;
    border:1px solid #CBD5E1;
    padding:20px;
    width:100%;
`

export const MiniMiniHeading = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:13px;
    font-family: newFontFaceBold;
    color: #1E293B;
`


export const MiniMiniHeadingBlue = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:13px;
    font-family: newFontFaceBold;
    color: #71A3F6
`

export const InputContainer = styled.div`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    border-radius:50px;
    width:100%;
    flex-grow:1;
    flex-shrink:1;
    border: 1px solid ${props => props.disabled ? 'transparent' : '#CBD5E1'};
    overflow:hidden;
    padding:10px ${props => props.disabled ? '0px' : '10px'};
    gap:10px;
    transition: all 0.5s;
    background: ${props => props.disabled ? 'transparent' : 'rgba(237, 241, 245, 0.5)' };
`

export const MiniHeadingDescriptor = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:12px;
    font-family: newFontFaceLight;
    color:#475569;
`


export const MiniHeadingDescriptorEdit = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:12px;
    font-family: newFontFaceLight;
    color:#3a8ef6;
    cursor:pointer;
`



export const MiniHeadingDescriptorGray = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    font-size:12px;
    font-family: newFontFace;
    color:#B1B5BA;
`

export const SettingsBoxHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
`

export const SettingsBoxLeft = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    padding:10px;
`


export const SettingsBoxRightHead = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;
    border-radius:100px;
    transition: all 0.5s;
    cursor:pointer;
`


export const SettingsBoxRight = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:center;
    width:100%;
    flex-grow:1;
    flex-shrink:1;
    background:#ffffff;
    border-radius:30px;
    border: 1px solid #E2E8F0;
    padding:20px;
    gap:20px;
`

export const FreshPage = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
`

    // background: ${props => props.outline ? '#FFFFFF' : 'transparent'};
// EDF1F5
export const TopBarSettings = styled.div`

`

export const SettingsPageOutline = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
    gap:30px;
    padding:20px;
    overflow:scroll;
    max-width:800px;
    transition: all 0.5s;
    padding-top: ${props => props.focus ? '100px' : '20px'};

`

export const ConversationPanel = styled.div`
    display:flex;
    flex-direction:column-reverse;
    justify-content:flex-start;
    align-content:center;
    align-items:flex-end;
    height:100%;
    width:100%;
    max-width:800px;
    overflow:scroll;
    flex-grow:1;
    flex-shrink:1;
    padding-bottom:100px;
    padding-top:100px;
`


export const CallSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    flex-grow:1;
    flex-shrink:1;
    width:100%;
    height:100%;
    padding-left:20px;
    padding-right:20px;
    padding-bottom:100px;
    z-index:10;
` 

export const ConversationSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    overflow:hidden;
    width:100%;
    height:100%;
` 

export const TopBarBackground = styled.div`
     display:flex;
    flex-direction:column;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    flex-grow:0;
    flex-shrink:0;
    height:100px;
    border-bottom:1px solid ${props => props.showBorder ? '#d5d5d5' : 'transparent'} ;
    width:100%;

`

export const ConversationSectionVideo = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    width:100%;
    height:100vh;
    overflow:hidden;
` 

export const ConversationHeading = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    flex-grow:0;
    flex-shrink:0;
    height:100px;
    background:transparent;
    padding:20px;
    gap:20px;
    position:absolute;
    top:0;
    z-index:5000;
    transition: all 1s;
    
` 

// #EDF1F5

export const PromptSection = styled(motion.div)`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    flex-grow:0;
    flex-shrink:0;
    width:100%;
    padding:20px;
    padding-bottom:${props => props.videoMode ? '100px' : '20px'};
    position: absolute;
    bottom:0;
    transition: all 0.5s;
    z-index:1000;
` 

  



export const CallToActionDescription = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    color:#a9a9a9;
    padding:20px;

`

export const CallToActionButton = styled.button`
    color:#ffffff;
    box-sizing:border-box;
    font-size:17px;
    outline:0;
    cursor:pointer;
    transition: all 0.5s;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(60, 181, 152);
    border-radius:10px;
    border: 1px solid transparent;
    box-shadow: #e5e5e5 0px 7px 14px 0px, #e5e5e5 0px 3px 6px 0px;
    padding:10px 30px;

    opacity: ${props => props.disabled ? '0.3' : '1.0'}
    
    font-weight:bold;

    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }
`


export const CallToActionButtonLink = styled(Link)`
    color:#ffffff;
    box-sizing:border-box;
    font-size:17px;
    outline:0;
    cursor:pointer;
    transition: all 0.5s;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: rgb(60, 181, 152);
    border-radius:10px;
    border: 1px solid transparent;
    box-shadow: #e5e5e5 0px 7px 14px 0px, #e5e5e5 0px 3px 6px 0px;
    padding:10px 30px;
    text-decoration: none;

    opacity: ${props => props.disabled ? '0.3' : '1.0'}
    
    font-weight:bold;

    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:focus {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }
`

export const ButtonDefined = styled.div`
    color: ${props => props.type === 'edit' ? '#000000' : '#ffffff'};
    box-sizing:border-box;
    font-size:15px;
    padding: 15px 20px;
    outline:0;
    cursor:pointer;
    display:flex;
    flex-direction:row;
    transition: all 0.5s;
    background: rgb(77, 192, 233);
    border-radius: ${props => props.setBorderRadius || '5px'};
    border: 1px solid transparent;
    box-shadow: transparent 0px 7px 14px 0px, transparent 0px 3px 6px 0px;
    opacity: ${props => props.disabled ? '0.3' : '1.0'};
    width:  ${props => props.setWidth || '100%'};
    text-decoration:none;
    justify-content:center;
    align-items:center;
    align-content:center;

    &:hover {
        transition: all 0.3s;
        transform: scale(0.95);
    }

    &:active {
        transition: all 0.3s;
        transform: scale(0.9);
    }


`



export const MiniResponse = styled.span`
    position:relative;
    z-index: 100;
    border-radius:10px;
    transition: all 0.3s;
    padding:5px;
    color: rgb(26, 55, 100);

`




export const CallToActionSectionOther = styled.div`
    display:flex;
    flex-grow:0;
    flex-shrink:0;
    width:100vw;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    position:relative;
    box-sizing:border-box;
    z-index:1;
    transition: all 0.5s;
    padding:50px;
    padding-top:100px;
`

export const AccessSection = styled.div`
    display:flex;
    flex-grow:0;
    flex-shrink:0;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
`

export const CallToActionSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  /* use 100% to avoid horizontal scrollbars from 100vw */
  width: 100%;

  /* full-screen height, but still grows with content */
  min-height: 100vh;       /* fallback */
  min-height: 100svh;      /* better on mobile browsers */

  padding-bottom: 50px;

  /* clip bg image to rounded corners */
  overflow: hidden;

  /* fallback color */
  background: #e8ecf0;

  /* background image layer */
  &::before {
    content: "";
    position: absolute;
    inset: 0;                      /* top/right/bottom/left: 0 */
    background-image: url(${p => p.image});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;                    /* behind content */
    opacity:20%;
  }

  /* ensure children sit above the ::before bg */
  > * {
    position: relative;
    z-index: 1;
  }

  scroll-snap-align: start;
`;

export const TopGap = styled.div`
    height:150px;
    width:100%;
`

export const BottomGap = styled.div`
    height:100px;
    width:100%;
`


export const CallToActionSectionWhite = styled.div`
    display:flex;
    width:100vw;
    height:auto;
    min-height:100%;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    position:relative;
    box-sizing:border-box;
    z-index:1;
    background: ${props => props.color};
    transition: all 0.5s;
    z-index:0;
    scroll-snap-align: start;
    border-bottom:1px solid #e4e4e4;
`

export const CallToActionSectionBlue = styled.div`
    display:flex;
    flex-grow:0;
    flex-shrink:0;
    width:100vw;
    height:100%;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    align-content:flex-start;
    position:relative;
    box-sizing:border-box;
    z-index:1;
    background: ${props => props.color};
    transition: all 0.5s;
    z-index:0;
    scroll-snap-align: start;
`


export const HeadingOverall = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    max-width:850px;
    height:100%;
`


export const HeadingOverallNew = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    max-width:850px;
    height:100%;
    color: #a9a9a9;
`

export const HeadingOverallColumn = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    
`


export const HeadingOverallColumnNew = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    height:100%;
    gap:20px;
    
`


export const HeadingOverallColumnEnd = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
    align-items:flex-end;
    align-content:flex-end;
    width:100%;
    
`

export const Overlay = styled.div`
    display:flex;
    height:0;
    width:inherit;
    max-width:850px;
    z-index:1000;
    margin-top:0%;

`

export const HeadingOverallRow = styled.div`

    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    gap: 30px;
    max-width:850px;
    width:100%;
    height:100%;
`   

export const AgentOrgChart = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap:30px;
    overflow-y:scroll;
    height:100%;
    width:100%;

`

export const AllConnections = styled.div`
    display: flex;
    flex-direction:column;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    gap:30px;
    overflow-y:scroll;
    width:100%;
    height:100%;
    padding-top:50px;
    padding-bottom:50px;
`

export const AgentSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:#ffffff;
    width:100px;
    height:100px;
    border-radius:100px;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 20px 0px, rgba(0, 0, 0, 0.12) 0px 0px 20px 0px;
    transition: all 0.5s;
`

export const ConnectionSection = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    gap: 10px;
    background:#ffffff;
    padding:20px;
    border-radius:20px;
    width:100%;
    height:120px;
    box-shadow: rgba(3, 9, 50, 0.04) 0px 24px 32px -3px;
`


export const CustomerComment = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:#ffffff;
    padding:10px 30px;
    border-radius:50px;
    width:350px;
    height:150px;
    box-shadow: rgba(3, 9, 50, 0.04) 0px 24px 32px -3px;
`


export const HeadingOverallRowInner = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap: 30px;
    max-width:850px;
    width:100%;

`   


export const HeadingOverallRowInneInner = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap: 30px;
    width:100%;
    border:1px solid #e5e5e5;
    border-top-left-radius:150px;
    border-bottom-left-radius:150px;
    border-top-right-radius:50px;
    border-bottom-right-radius:50px;
    background:#f7f7f7;

`   



export const HeadingOverallRowInnerNew = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    gap: 30px;
    max-width:850px;
    width:100%;
    height:100%;

`   


export const HeadingOverallColInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap: 10px;
    max-width:850px;
    width:100%;

`   

export const StackTitle = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    border-radius:50px;
    font-family: newFontFaceBold;
`

const scrollLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } /* scroll only half, because it's duplicated */
`;

const scrollRight = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(50%); } /* scroll only half, because it's duplicated */
`;


export const ScrollContent = styled.div`
  display: flex;
  width: 200%; /* twice the original content */
  animation: ${props => props.direction == 'left' ? scrollLeft : scrollRight} 60s linear infinite;
`;

export const StackIcons = styled.div`
    display: flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:20px;

`

export const StackIconLogo = styled.img`

    display:block;
    justify-content:center;
    align-items:center;
    padding:10px;
    height: ${props => !!props.height ? props.height : 'auto'};
    width: ${props => !!props.width ? props.width : 'auto'};
    transition: all 0.3s;
    object-fit: cover;

`

export const SolutionStack = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    background: #EDF1F5;
    width:100%;
    padding:20px;
    overflow:hidden;
    border-radius:100px;

`


export const SolutionStackInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    overflow:hidden;

    mask-image: linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%);
    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%);

`


export const HeadingOverallRowLeft = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
`   


export const HeadingPage = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:15px;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;
    padding-bottom:20px;
`

export const HeadingOverallSimpleMini = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:15px;
    color: #a9a9a9;
    font-family: newFontFace;
    padding:0;
    margin:0;
    padding-bottom:5px;


     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`


export const CustomerName = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    width:100%;
    align-content:center;
    font-size:15px;
    color: #00BFA5;
    font-family: newFontFace;
    padding:0;
    margin:0;
`


export const HeadingOverallSimpleMiniSmooth = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:20px;
    color: #00BFA5;
    font-family: newFontFace;
    padding:0;
    margin:0;
    padding-bottom:5px;
    text-align:center;
    width:100%:

`

export const HeadingOverallSimple = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:40px;
    color: #031432;
    font-family: headingNewFontFace;
    padding:0;
    margin:0;
    line-height: 1.1;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`


export const HeadingSmaller = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:17px;
    color: #031432;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;

`


export const AgentOptions = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:20px;
    width:100%;
    gap:10px;

`

export const EachAgentOption = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    border-radius:10px;
    background: #ffffff;
    width:100%;
    overflow:hidden;
    cursor: grab;
    transition: all 0.3s;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 7px 0px, rgba(0, 0, 0, 0.12) 0px 0px 7px 0px;
    transform: scale(1);        

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 10px 0px, rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;
        transform: scale(1.05);  
    }
`


export const CapabilityChooserIcon = styled.img`
    width:70px;
    height:auto;
    opacity:0.5;
`


export const EachAgentOptionPlaceholder = styled.div`

    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    border-radius:10px;
    background: rgba(255,255,255,0.3);
    overflow:hidden;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: rgba(60, 66, 87, 0.06) 0px 3px 7px 0px, rgba(0, 0, 0, 0.06) 0px 0px 7px 0px; 
    gap:10px;
    padding-left:15px;
    width:100%;

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 10px 0px, rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;
        transform: scale(1.05);  
    }
`


export const OverallCombination = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    padding-bottom:50px;
`


export const EachAgentOptionPlaceholderMain = styled.div`

    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    border-radius:100px;
    overflow:hidden;
    cursor: pointer;
    transition: all 0.3s;
    gap:10px;
    width:100px;
    height:100px;
    background: rgba(255,255,255,0.5);
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 10px 0px, rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;


    &:hover {
        transform: scale(1.05);  
        box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 15px 0px, rgba(0, 0, 0, 0.12) 0px 0px 15px 0px;
    }
`


export const EachIconOption = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    border-radius:10px;
    background: #ffffff;
    width:100%;
    overflow:hidden;
    cursor:pointer;
    transition: all 0.3s;
    padding:20px;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 7px 0px, rgba(0, 0, 0, 0.12) 0px 0px 7px 0px;
    transform: scale(1);        

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 10px 0px, rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;
        transform: scale(1.05);  
    }
`


export const HeadingOverallSimpleLeft = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    font-size:40px;
    color: #031432;
    font-family: headingNewFontFace;
    padding:0;
    margin:0;
    line-height: 1.1;
    width:100%;
    padding-bottom:30px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`


export const Bolding = styled.span`
    font-size:35px;
    color: #000000;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;
    line-height: 1.1;
    padding-bottom:20px;
    @media (max-width: 599px) {
        font-size:30px;
    }
`

export const HeadingOverallSimpleFlatSmallerNew = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:30px;
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1.1;
    width:300px;
    height:300px;
    flex-grow:0;
    flex-shrink:0;
    border-radius:100%;
    flex-wrap:wrap;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 20px 0px, rgba(0, 0, 0, 0.12) 0px 0px 12px 0px;
    z-index:10000;
    text-align:center;
     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`

export const HeadingOverallSimpleFlatSmaller = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:35px;
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1.1;
    margin-left:-2px;
    padding-bottom:20px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`


export const HeadingOverallSimpleFlatSmallerBold = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:35px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
    line-height: 1.1;
    margin-left:-2px;
    padding-bottom:10px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`

export const ContactShowRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:20px;
    padding:10px 20px;
    border-radius:100px;
    background:#ffffff;
    border:1px solid #e5e5e5;

`


export const HeadingOverallSimpleFlatSmallerMe = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:20px;
    color: rgba(0,0,0,0.7);
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1;
    background:#e5e5e5;
    padding:5px 10px;
    border-radius:20px;
    position:relative;
    left:5px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`



export const HeadingOverallSimpleFlatSmallerMeNew = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:25px;
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1;
    margin-left:-2px;
    

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`



export const CustomerHeading = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:35px;
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    text-align:center;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`

export const MainSubHeadingName = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:14px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
    border-radius:10px;
`



export const MainSubHeadingNameNew = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:14px;
    color: #000000;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;
    border-radius:10px;
`



export const MainSubHeadingSmall = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:12px;
    color: #a9a9a9;
    font-family: newFontFace;
    padding:0;
    margin:0;
`


export const MainSubHeadingSmallName = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:12px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
`

export const HeadingAgentNameSmaller = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    font-size:13px;
    color: #000000;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;
`

export const HeadingAgentNameSmallerSoft = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    font-size:13px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
`




export const HeadingAgentNameSmallerBold = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:16px;
    color: #000000;
    font-family: newFontFaceBold;
    padding:0;
    margin:0;
    width:100%;
`

export const HeadingAgentName = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:22px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
    width:100%;
`

export const HeadingAgentNameTotal = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    text-align:center;
    font-size:26px;
    color: #000000;
    font-family: newFontFace;
    padding:0;
    margin:0;
    width:100%;
    padding-bottom:50px;
`




export const HeadingOverallSimpleFlat = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:40px;
    
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1.1;
    margin-left:-2px;
    padding-bottom:20px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`



export const HeadingOverallSimpleFlatSmall = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:20px;
    
    color: #000000;
    font-family: newFontFaceLight;
    padding:0;
    margin:0;
    line-height: 1.1;
    margin-left:-2px;
    padding-bottom:50px;

     /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }

`

export const HeadingOverallComplex = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:25px;
    background-image: linear-gradient(90deg, #24D3FF 40%, #008FC5);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    font-size:50px;
    font-weight:bold;
    font-family: headingNewFontFace;

    /* Less than 599px */
    @media (max-width: 599px) {
        font-size:30px;
    }
`

export const HeadingOverallComplexSmall = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background-image: linear-gradient(90deg, #24D3FF 40%, #008FC5);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    font-size:30px;
    font-weight:bold;
    font-family: headingNewFontFace;
    flex-grow:0;
    flex-shrink:0;
    padding-left:5px;
    padding-right:5px;
`


export const HeadingOverallComplexSmallFull = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background-image: linear-gradient(90deg, #24D3FF 40%, #008FC5);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    font-size:40px;
    font-weight:bold;
    font-family: headingNewFontFace;
    flex-grow:0;
    flex-shrink:0;
    padding-left:20px;
    padding-right:20px;
`


export const HeadingOverallSimpleSmall = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #000000;
    font-size:30px;
    font-weight:bold;
    font-family: headingNewFontFace;
    flex-grow:0;
    flex-shrink:0;
    padding-left:5px;
    padding-right:5px;
`



export const IconWrapper = styled.span`
    transition: all 0.3s;
    position:relative;
    width:0px;
    height:28px;
    left:0px;
`


export const MainButton = styled.button`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 40px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #000000 0%,#a9a9a9 200%);
    border-radius:10px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`



export const MainButtonFullSmall = styled(Link)`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 5px 20px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:100px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:14px;
    gap: 10px;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`


export const MainButtonFullWidth = styled(Link)`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 40px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:100px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;
    width:100%;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`

export const MainButtonSmall = styled(Link)`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 20px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:100px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;
    opacity:0.7;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);
        opacity:1.0;

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`


export const MainButtonFull = styled.button`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 40px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:100px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;
    width:100%;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`

export const FullPageOrientator = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:flex-end;
    align-items:center;
    align-content:center;
    width:100%;

`

export const MainButtonSmaller = styled.button`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 40px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background:linear-gradient(85deg, #3A8EF6 0%, #6F3AFA 200%);
    border-radius:100px;
    border: none;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);

        & > ${IconWrapper} {
            left:10px;
        }
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`

export const MainButtonText = styled.span`
    font-weight:bold;
    font-size:16px;
    color:#ffffff;
    display:flex;
`


export const MainButtonTextSmall = styled.span`
    font-size:13px;
    color:#ffffff;
    display:flex;
`

export const MainDisplayImage = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    transition: all 0.3s;
    width:30%;
    border-radius:20px;
    margin-top:18px;
     border:1px solid #d4d4d4;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 0px 5px 0px, rgba(0, 0, 0, 0.12) 0px 0px 5px 0px;
   
`

export const AgentNodeLink = styled(Link)`
    display:flex;
    justify-content:center;
    align-items:center;

`


export const GeneralImageWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    height:50px;
    overflow:hidden;
`

export const TopDescripter = styled.div`
  width: 100%;
  font-size: 13px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  align-items: center;
  border-radius: 8px 8px 0 0;
  transition: all 0.5s;

  ${props =>
    props.$active
      ? css`
          color: #ffffff;
            background-image: linear-gradient(
            120deg,
            #ff6ec4,
            #7873f5,
            #4adeDE,
            #ff6ec4
          );
          background-size: 300% 300%;
          border-bottom:1px solid transparent;
          animation: ${animateRainbow} 4s linear infinite;
        `
      : css`
          background-color: #f9f9f9;
          color: #a1a1a1;
          border-bottom:1px solid #e5e5e5;
        `}
`;


export const GeneralImage = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    height:30px;
    transition: all 0.7s;
    opacity:1;
`

export const AvaImage = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:80px;
    transition: all 0.7s;
    opacity:1;
    border-radius:50%;
`

export const AnotherDisplayImage = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    max-width:400px;
    transition: all 0.7s;
    border-radius:100px;
    opacity:1;

    &:hover {
        opacity:0.5;
    }
`

export const OveralInfoLayer = styled.div`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    position:absolute;
    top:110px;
`


export const DetailAgentInternal = styled.div`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    border-radius:10px;
    background:rgba(255,255,255,0.5);
    padding:5px;


`

export const DetailAgent = styled.div`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    border-radius:10px;
    background:rgba(255,255,255,0.5);
    padding:5px;


`

export const CapabilitiesBreakdown = styled.div`
    display: flex;
    flex-direction:column;
    align-content:flex-start;
    justify-content: flex-start;
    align-items:flex-start;
    gap:5px;
    width:100%;
    padding-top:10px;
`

export const Capability = styled.div`
    display: flex;
    flex-direction:row;
    justify-content: flex-start;
    align-items: center;
    align-content:center;
    font-family: newFontFace;
    font-size: 12px;
    width:100%;
    background:rgba(255,255,255,0.5);
    padding:2px;
    border-radius:10px;

`

export const CapabilityPlaceholder = styled.div`
    display: flex;
    flex-direction:row;
    justify-content: flex-start;
    align-items: center;
    align-content:center;
    font-family: newFontFace;
    font-size: 12px;
    width:100%;
    background:#e5e5e5;
    padding:2px;
    border-radius:10px;

`

export const AnotherDisplayVideo = styled.video`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 600px;
  transition: all 0.3s;
  object-fit: contain;
  border-radius:30px;
  box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 20px 0px, rgba(0, 0, 0, 0.12) 0px 0px 20px 0px;
`;

export const SmallerDisplayImage = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:50%;
    border-radius: 20px;
    transition: all 0.3s;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 20px 0px, rgba(0, 0, 0, 0.12) 0px 0px 20px 0px;
    transform:rotate(-20deg);
    position:absolute;
    right:-10%;
    top:10%;

    @media (max-width: 599px) {
        display:none;
    }
`



export const AvatarIconContainer = styled.div`
    display:flex;
    justify-content:flex-end;
    align-items:flex-end;
    width:40px;
    height:50px;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
`


export const AvatarIconContainerMain = styled.div`
    display:flex;
    justify-content:center;
    align-items:flex-end;
    width:100px;
    height:110px;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
`


export const LogoIconContainer = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:20px;
    height:60px;
`



export const AvatarIconContainerInner = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:75px;
    height:75px;
    background:#ffffff;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
    overflow:hidden;
    border-radius:100px;
    border:1px solid #e5e5e5;
`


export const AvatarIconMini = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:45px;
    padding-top:5px;
`

export const AvatarIcon = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:70px;
`


export const AvatarIconAdderMain = styled.img`
    display:flex;
    align-item:center;
    justify-content:center;
    align-items:center;
    width:78px;
    opacity:0.5;
`

export const AvatarIconAdder = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:40px;
    opacity:0.5;
`


export const LogoIcon = styled.img`
    max-height: 100%;
    width: auto;
    object-fit: contain;
`


export const AvatarLarge = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain; /* or 'cover' depending on what you want */
    max-height: 100%;
`

export const AvatarNaming = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    flex-grow:1;
    flex-shrink:0;
`

export const AvatarNamingInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    flex-grow:1;
    flex-shrink:0;
    width:100%;
`

export const AvatarButtons = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    gap:10px;
    flex-grow:0;
    flex-shrink:0;
` 

export const AvatarButtonOption = styled(Link)`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    border-radius:50px;
    background:rgba(255,255,255,0.8);
    cursor:pointer;
    height:40px;
    width:40px;
    text-decoration: none;
    transform: scale(1.0);
    transition: all 0.6s;
    border:2px solid ${props => props.$active ? 'rgba(0,0,0,0.7)' : 'transparent'};
    color: rgba(0,0,0,0.7);

    &:visited {
        color: rgba(0,0,0,0.7);        /* Prevent purple on visited */
    }

    &:hover {
        transform: scale(1.05);
        background:#d0d9e4;
    }
` 

export const AvatarButtonOptionButton = styled.button`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:8px;
    border-radius:50px;
    background:${props => props.$active ? `rgba(255,255,255,0.8)` : `transparent`};
    cursor:pointer;
    height:40px;
    width:40px;
    text-decoration: none;
    transform: scale(1.0);
    transition: all 0.6s;
    border:2px solid ${props => props.$active ? 'rgba(0,0,0,0.7)' : 'transparent'};
    color: rgba(0,0,0,0.7);

    &:visited {
        color: rgba(0,0,0,0.7);        /* Prevent purple on visited */
    }

    &:hover {
        transform: scale(1.05);
        background:#d0d9e4;
    }
` 


export const AvatarButtonOptionButtonAll = styled.button`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:8px;
    border-radius:50px;
    background:rgba(255,255,255,0.8);
    cursor:pointer;
    height:40px;
    width:auto;
    text-decoration: none;
    transform: scale(1.0);
    transition: all 0.6s;
    border:2px solid ${props => props.$active ? 'rgba(0,0,0,0.7)' : 'transparent'};
    color: rgba(0,0,0,0.7);

    &:visited {
        color: rgba(0,0,0,0.7);        /* Prevent purple on visited */
    }

    &:hover {
        transform: scale(1.05);
        background:#d0d9e4;
    }
` 



export const SendButton = styled.button`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    border-radius:50px;
    background:rgba(0,171,148,1);
    border:none;
    cursor:pointer;
    height:40px;
    width:40px;
    text-decoration: none;
    transform: scale(1.0);
    transition: all 0.6s;
    color: rgba(255,255,255,0.7);

    &:visited {
        color: rgba(255,255,255,0.7);        /* Prevent purple on visited */
    }

    &:hover {
        transform: scale(1.05);
        background:rgba(0,191,165,1);
    }
` 


export const InputButtonsColumn = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    gap:5px;
    height:100%;
`

export const TranscriptionDisplay = styled.span`
    font-family: newFontFace;
    font-size:15px;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
    text-align:center;
    gap:20px;
`


export const BottomButtonPanel = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    padding:10px;

`

export const ButtonsGroupLeft = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;
`


export const ButtonsGroupRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;
`



export const AddButton = styled.button`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:10px;
    border-radius:50px;
    background:transparent;
    border:none;
    cursor:pointer;
    height:40px;
    width:40px;
    text-decoration: none;
    transform: scale(1.0);
    transition: all 0.6s;
    color: rgba(0,0,0,0.7);

    &:visited {
        color: rgba(0,0,0,0.7);       /* Prevent purple on visited */
    }

    &:hover {
        transform: scale(1.01);
        background:#d9d9d9;
    }
` 


export const AvatarNameOne = styled.span`
    font-size:14px;
    font-family: newFontFaceBold;
    color: ${props => props.videoMode ? '#ffffff' : '#000000'};
    transition: all 0.5s;
`

export const AvatarSecondRow = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    gap:5px;
`

export const AvatarNameTwo = styled.span`
    font-size:14px;
    font-family: newFontFaceLight;
    color: ${props => props.videoMode ? '#ffffff' : '#000000'};
    transition: all 0.5s;
`
export const AvatarNameThree = styled.span`
    font-size:14px;
    font-family: newFontFaceLight;
    text-decoration:underline;
    color: ${props => props.videoMode ? '#ffffff' : '#000000'};
    transition: all 0.5s;
`

export const ImagePositioning = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    flex-grow:0;
    flex-shrink:0;
    padding-top:100px;
    padding-bottom:100px;
    
`

export const Divider = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
`

export const DividerSides = styled.svg`
    flex-grow: 1;
    height: 1px;
    flex-direction:row;
    justify-content:flex-start;
`


export const DividerMiddle = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    height:1px;
    border-bottom:1px dashed #000;
    flex-grow:0;
    flex-shrink:0;
    padding-left:20px;
    padding-right:20px;
`



export const LeftSectionSalesBottom = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    padding-left:30px;
    width:50%;

    @media (max-width: 599px) {
        width:100%;
    }
    
`


export const BottomSectionBar = styled.div`
    display: flex;
    flex-direction:row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 30px;
    background: #000000;
    
    /* Ensure the bars stack vertically when screen width is less than 599px */
    @media (max-width: 599px) {
        flex-direction: column; /* Stack the bars */
        padding: 20px; /* Optional, for better spacing on smaller screens */
    }
`;

export const LeftBarBottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    gap: 10px;
    flex: 1; /* Take remaining space */

    /* Less than 599px */
    @media (max-width: 599px) {
    
        flex: 0; /* Remove flex-grow */
        width: 100%; /* Full width */
    }
`;



export const LogoGroup = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-content:center;
    align-items:center;
    padding:0px;
    box-sizing:border-box;
    z-index:10000;
    padding-bottom:20px;
`

export const LogoRight = styled.img`
    display:flex;
    flex-grow:0;
    width: 130px;
    object-fill:contain;
    padding:0px;
    box-sizing:border-box;
    cursor:pointer;

`

export const TextSectionBottomBar = styled.div`
    text-align: right; /* Center-align all text */
    font-size: 14px;
    color: #ffffff;
    line-height: 1.5;
`


export const TextSectionBottomOtherBold = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align: left; /* Center-align all text */
    font-size: 20px;
    color: #000000;
    line-height: 1.5;
    font-family:newFontFaceBold;
    padding-bottom:20px;
`


export const TextSectionBottomOtherBoldSmall = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align: left; /* Center-align all text */
    font-size: 14px;
    color: #000000;
    line-height: 1.5;
    font-family:newFontFaceBold;
    padding-bottom:20px;
    padding-top:20px;
`


export const TextSectionBottomOther = styled.div`
    text-align: left; /* Center-align all text */
    font-size: 14px;
    color: #000000;
    line-height: 1.5;
    padding:20px;
`

export const TextSectionBottomOtherNormal = styled.div`
    text-align: left; /* Center-align all text */
    font-size: 14px;
    color: #000000;
    line-height: 1.5;
    padding-bottom:10px;
`

export const NormalText = styled.span`
    display: inline; /* Allow wrapping */
    color: #ffffff;
    font-family:newFontFace;
`


export const BoldSomeTextPlain = styled.span`
    display: inline; /* Allow wrapping */
    color: #ffffff;
    font-family:newFontFaceBold;
`


export const BoldSomeTextLinked = styled(Link)`
    display: inline-block; /* Allow wrapping */
    color: #ffffff;
    font-family:newFontFaceBold;
    background:rgba(255,255,255,0.2);
    border-radius:30px;
    padding-top:5px;
    padding-bottom:5px;
    padding-left:10px;
    padding-right:10px;
    cursor:pointer;
    transition: all 0.3s;
    text-decoration:none;
    font-size:13px;

    &:hover {
        background:rgba(255,255,255,0.2);
    }
`


export const RightBarBottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: center;
    align-items:  flex-end;
    gap: 10px;
    width: 200px; /* Fixed width */

    /* Less than 599px */
    @media (max-width: 599px) {
        display:none;
    }
`;


export const EachLinkBottom = styled(Link)`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-content:center;
    align-items:center;
    color: rgba(255,255,255,0.5);
    font-size: 14px;
    text-decoration:none;
    cursor:pointer;
    transition: all 0.3s;
    padding:5px;
    white-space:nowrap;

    &:hover {
        color: rgba(255,255,255,1);
    }

    @media (max-width: 599px) {
        order: -1
    }

`


export const TryButtonLink = styled(Link)`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    color: #ffffff;
    box-sizing:border-box;
    font-size:13px;
    padding: 10px 0px;
    outline:0;
    cursor:pointer;
    text-decoration:none;
    transition: all 0.5s;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    background: #24D3FF;
    border-radius:5px;
    border: none;
    width: 100px;
    box-shadow: rgba(249, 249, 249, 0.12) 0px 7px 14px 0px, rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
    font-weight:bold;
    font-size:16px;
    gap: 10px;
    margin-bottom:10px;

    &:hover {
        transition: all 0.3s;
        transform: scale(1.05);
    }
    
    &:active {
        transition: all 0.3s;
        transform: scale(0.95);
    }

`


export const EachCompanyShown = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:#ffffff;
    padding:30px;
    gap:10px;
    width:100%;
    border-radius:30px;
    transition: all 0.3s;
    cursor:pointer;

    &:hover > ${IconRightGroupedHidden} {
       opacity:1;
    }

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.06) 0px 7px 10px 0px, rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
        transform: scale(1.01);
    }
    
    &:active {
        transform: scale(1);
    }
`

export const FarRightButton = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    opacity:0;
    transition: all 0.3s;
    width:50px;
`


export const EachUserShown = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    background:#ffffff;
    padding:30px;
    gap:10px;
    width:100%;
    border-radius:30px;
    transition: all 0.3s;
    cursor:pointer;

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.06) 0px 7px 10px 0px, rgba(0, 0, 0, 0.06) 0px 3px 10px 0px;
        transform: scale(1.01);
    }
    
    &:active {
        transform: scale(1);
    }

    &:hover > ${FarRightButton} {
        opacity:1;
    }
`


export const EachCompanyShownLogo = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    height:80px;
    width:80px;
    border-radius:30px;
    border:1px solid #d5d5d5;
    background:#f9f9f9;
    flex-grow:0;
    flex-shrink:0;

`
export const EachCompanyShownName = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:16px;
    font-family: newFontFaceBold;
`
export const EachCompanyShownLocation = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    font-size:13px;
    font-family: newFontFaceThin;
`
export const EachCompanyShownStaffCount = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding: 10px 20px;
    border-radius:30px;
    background: #B3AFAF;
    color:#ffffff;
    flex-grow:0
    flex-shrink:0;
    text-wrap:nowrap;
`

export const EachCompanyShownTitles = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:center;
    gap:10px;
`


export const CategoryMenuTop = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    height:40px;
    box-shadow: rgba(60, 66, 87, 0.06) 0px 3px 10px 0px, rgba(0, 0, 0, 0.06) 0px 1px 10px 0px;
    padding:30px 20px;
    z-index:100;
    background:#ffffff;
`

export const CategoryMenuList = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    gap:5px;
    width:100%;
    padding:10px;
    flex-wrap: wrap;
`

export const CategoryTagLabel = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;
    
    color: ${props => props.visible ? '#000000': '#a9a9a9'};
`


export const CategoryTagButtons = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:5px;
`

export const CategoryTagEachButton = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:5px;
    border-radius:20px;
    opacity: ${props => props.alwaysOn ? 0.5 : 0};
    transition: all 0.3s;

    &:hover {
        opacity:1;
    }
`

export const CategoryTag = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    gap:10px;

`

export const SaveStyled = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding:5px 10px;
    border-radius:20px;
    background: rgb(0, 205, 112);
    color:#ffffff;
    transition: all 0.3s;
    font-size:13px;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 3px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;


    &:hover {
        transform: scale(1.05);
    }

    &:active {
        transform: scale(1.0);
    }
`

export const CategoryIcon = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    opacity: ${props => props.alwaysOn ? 1 : 0};
    transition: all 0.3s;
`


export const EachCategoryRow = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:${props => !!props.setWidth ? props.setWidth : '100%'};
    padding:10px 10px;
    border-radius:10px;
    transition: all 0.3s;
    cursor:pointer;
    background: ${props => props.active ? 'rgba(77, 192, 233, 0.1)' : 'transparent'};

    &:hover {
        background: rgba(77, 192, 233, 0.1);
    }

    &:hover > ${CategoryIcon} {
        opacity:1;
    }
    
    &:hover > ${CategoryTag} > ${CategoryTagButtons} > ${CategoryTagEachButton} {
        opacity:0.5;
    }

    &:hover > ${CategoryTagButtons} > ${CategoryTagEachButton} {
        opacity:0.5;
    }
`


export const TopBarOption = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    align-content:center;
    width:100%;
    padding-bottom:20px;
    height:60px;

`



export const CategoryMenu = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:300px;
    background:#ffffff;
    border-radius:30px;
    height:100%;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;

    &:hover > ${CategoryMenuTop} > ${IconAnotherWrapperAnother} {
        background: #f9f9f9;
    }
`


export const CategoryMenuSecondBar = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    height:100%;
    overflow:hidden;
    flex-grow:0;
    flex-shrink:0;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.06) 0px 3px 10px 0px, rgba(0, 0, 0, 0.06) 0px 1px 10px 0px;

    &:hover > ${CategoryMenuTop} > ${IconAnotherWrapperAnother} {
        background: #f9f9f9;
    }
`



export const CategoryMenuSecond = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    align-content:flex-start;
    width:100%;
    background:#ffffff;
    border-radius:30px;
    height:100%;
    overflow:hidden;

    &:hover > ${CategoryMenuTop} > ${IconAnotherWrapperAnother} {
        background: #f9f9f9;
    }
`


export const UpdateDetailsSection = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%;
    background:#ffffff;
    border-radius:30px;
    min-width:400px;
    padding:40px;

    &:hover > ${TopBarOption} > ${IconAnotherWrapperAnother} {
        background: #f9f9f9;
    }
`


export const UpdateDetailsSectionNew = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;
    align-content:center;
    width:100%;
    background:#ffffff;
    border-radius:30px;
    padding:40px;

    &:hover > ${TopBarOption} > ${IconAnotherWrapperAnother} {
        background: #f9f9f9;
    }
`

export const DisplayPictureSection = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:200px;
    flex-grow:0;
    flex-shrink:0;
    background:#ffffff;
    border-radius:30px;
    padding:20px;
    gap:20px;
    
`

 export const MainDisplayImageOther = styled.img`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100px;
    height:100px;
    border-radius: 20px;
    transition: all 0.3s;
    border: 1px solid rgba(36, 211, 255, 0.5);
`

export const MainDisplayTitle = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-size:16px;
    color:#090909;
    text-decoration:none;
    width:100%;
    font-family: newFontFaceBold;
    text-align:center;
`

export const MainDisplayAddress = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    font-size:16px;
    color:#090909;
    text-decoration:none;
    width:100%;
    font-family: newFontFaceThin;
    text-align:center;
`



export const TopSection = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width:100%;
    padding:20px 20px;
    flex-grow:0;
    flex-shrink:0;
    
`


export const  SectionOutline = styled.div`
    display:flex;
    flex-direction:${props => props.type === 'row' ? 'row' : 'column' };
    justify-content:flex-start;
    align-items:flex-start;
    width:500px;
    padding-top:20px;
    flex-grow:0;
    flex-shrink:0;
`


export const  SectionOutlineOther = styled.div`
    display:flex;
    flex-direction:${props => props.type === 'row' ? 'row' : 'column' };
    justify-content:flex-start;
    align-items:flex-start;
    width:100%;
    flex-grow:0;
    flex-shrink:0;
    padding-top:10px;
`


export const HeadingOfProducts = styled.span`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    width:100%;
    font-size:21px;
    color: #1A3B67;
`


export const HeadingCategories = styled.div`
    display:flex;
    justify-content:flex-start;
    align-items:center;
    width:100%;
    color: #1A3B67;
    gap: 10px;
`




export const DataTable_Linker = styled(Link)`
    padding:0;
    width:100%;
    margin: 0;
    border-bottom:1px solid #e9e9e9;

    &:last-child {
        border-bottom:none;
    }
`


export const DataTable_FlexContainer = styled.div`
    display:flex;
    flex-wrap: nowrap;
    flex-direction:column;
    justify-content:flex-start;
    align-content:center;
    align-items:center;
    width:100%;
    box-sizing:border-box;
    border-radius:10px;
    overflow:hidden;

    
`



export const DataTable_VeryBottomOfTable = styled.div`
    width:100%;
    height: 50px;
    box-sizing:border-box;
    padding:20px 20px;
    border-right:1px solid transparent;
    border-top:1px solid #e9e9e9;
    border-left:1px solid transparent;
    background:#ffffff;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-content:center;
    align-items:center;
    min-width:500px;
    flex-shrink:0;
    flex-grow:0;
    box-shadow: rgba(60, 66, 87, 0.02) 0px -4px 4px 0px, rgba(0, 0, 0, 0.02) 0px -2px 4px 0px;
    z-index:10000;
`

export const DataTable_R = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items: ${props => props.flexType};
    align-content:center;
    box-sizing:border-box;
`

export const DataTable_ConcatWithInput = styled.span`
    font-size:15px;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
    padding-right:10px;
    padding-left:10px;
    
`

export const DataTable_TopOfTableLeft = styled.div``

export const DataTable_TopOfTableRight = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    align-content:center;
`

export const DataTable_PageNoList = styled.ul`
    text-decoration:none;
    width:${props => props.setWidth};
    position:relative;
    cursor:pointer;

`



export const DataTable_EachNo = styled.li`

    background:#ffffff;
    text-align:left;
    padding:5px 10px;
    position:relative;
    box-sizing:border-box;
    width:100%;
    list-style-type: none;
    cursor: pointer;
    border-bottom:1px solid #e5e5e5;
    border-left:1px solid #e5e5e5;
    border-right:1px solid #e5e5e5;

    &:hover {
        background:#eefbfb;
        color: #000000;
    }

`




export const DataTable_StartText = styled.div`
    padding-right:10px;
`

export const DataTable_StartTextShort = styled.div`
    padding:5px;
    background:#f3f3f3;
    border-radius:5px;
`


export const DataTable_EndText = styled.div`
    padding-left:10px;
`

export const DataTable_GroupOfEachNo = styled.ul`
    position:absolute;
    bottom:0;
    box-sizing:border-box;
    width:100%;
    display:none;
    text-decoration:none;
    margin: 0;
    padding: 0;
    text-align: center;
    max-height:200px;
    overflow:scroll;

`

export const DataTable_ArrowAlign = styled.div`
    display:flex;
    flex-direction:row;
    flex-wrap:nowrap;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
`

export const DataTable_ArrowButton = styled.button`
    background:#ffffff;
    outline:none;
    height:25px;
    width:25px;
    display:flex;
    flex-direction:row;
    flex-wrap:nowrap;
    justify-content:center;
    align-items:center;
    align-content:center;
    border:1px solid #e5e5e5;
    border-radius:2px;
    cursor:pointer;
    
    &:hover {
        background:#f9f9f9;
    }

`

export const DataTable_ArrowGroup = styled.span`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:space-between;
    align-content:space-between;
    width: ${props => Number(props.setWidth) + 'px'};


`

export const DataTable_PageInput = styled.input`
    padding:5px 0px;
    font-size:15px;
    background:transparent;
    border-radius:0px;
    border:1px solid #e5e5e5;
    text-align:center;
    outline:none;
    width:35px;
    
    &:hover {
        background:#f9f9f9;
    }

    &:focus {
        background:#f9f9f9;
    }

`

export const DataTable_BorderGap = styled.div`
    padding-left:10px;
    border-right:1px solid #e5e5e5;
    height:28px;
    width:1px;
`

export const DataTable_Container = styled.div`
    display:flex;
    flex-wrap: nowrap;
    flex-direction:column;
    justify-content:flex-start;
    align-content:center;
    align-items:center;
    width:100%;
    overflow:scroll;
`

export const DataTable_Table = styled.table`
    border-collapse: collapse;
    position:relative;
    top:0;
    left:0;
    flex-shrink:0;
    display:block;
    flex-grow:1;
    width:100%;
    box-sizing:border-box;
    top:0;
    z-index: 1;
    overflow-x: scroll;
    overflow-y: scroll;
    background:#ffffff;
`

export const DataTable_TableCell = styled.td`
    padding: 20px 8px;
    height:inherit;
    display:flex;
    justify-content:center;
    align-items:center;
    height:100%;
    width:100%;

`


export const DataTable_TableCellLeft = styled.div`
    padding: 20px 8px;
    height:inherit;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    height:100%;
    width:100%;
`



export const DataTable_TableHeader = styled.th`
    padding: 20px 8px;
    display:flex;
    justify-content:center;
    align-items:center;
    width:inherit;
    height:inherit;
`

export const DataTable_TableHeaderLeft = styled.th`
    padding: 20px 8px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    width:inherit;
    height:inherit;
`

export const DataTable_TableRowHeader = styled.tr`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    width:100%;
    box-sizing:border-box;
    background:#ffffff;
    border-bottom:1px solid #e9e9e9;
    height:60px;
    box-shadow: rgba(60, 66, 87, 0.02) 0px 4px 4px 0px, rgba(0, 0, 0, 0.02) 0px 2px 4px 0px;
    z-index:10000;
`

export const DataTable_IconRightGrouped = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: center;
    align-content:center;
    align-items:center;
    position:absolute;
    height:0px;
    width:0px;
    right:25px;
    transition: all 0.3s;
`


export const DataTable_TableRow = styled.tr`

    display:flex;
    flex-direction:row;
    justify-content:flex-start
    align-content:center;
    align-items:center;
    width:100%;
    min-height:60px;
    box-sizing:border-box;
    background:#ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: rgb(77, 192, 233, 0.1);
        transform: scale(1.005);
        margin-left:-1.3px;
      
        & > ${IconRightGrouped} {
            right:20px;
        }
    }

    &:active {
        transform: scale(1);
        margin-left:0px;
    }
`




export const DataTable_TableHead = styled.thead`

    box-sizing:border-box;
    display:flex;
    flex-direction:row;
    width:100%;

    & > ${TableRow}:first-child {
        border-top: none;
    }

`

export const DataTable_TableBody = styled.tbody`
    display:flex;
    flex-direction:column;
    width:100%;
    overflow:scroll;
    background:#ffffff;
    box-sizing:border-box;
`
